<template>
<transition name="fade">
    <div id="next-revision-step-3" v-if="isReady">

        <base-modal :persistent="true" v-model="progressBar.show" :title="$t('module-budget.main-budget.loading.title')" modal-width="600px">
            <template v-slot:modal-body>
                <v-card style="display: flex; justify-content: center; height: 80px;" elevation="0">
                <span class="spans-loading" v-if="progressBar.showMessage">
                    <img src="/images/_SVGs/bo/check-circle.svg" onload="SVGInject(this)" width="18" height="18"/>
                    {{ progressBar.visualMessage }}
                </span>
                </v-card>
                <div class="w-100 pl-15 pr-15">
                    <v-progress-linear
                        buffer-value="100"
                        color="primary"
                        v-model="progressBar.percentage"
                        height="35"
                        rounded
                        style="pointer-events: none"
                    >
                        <template v-slot:default="{ value }">
                            <strong style="color: white; font-weight: bold">{{ Math.ceil(value) }}%</strong>
                        </template>
                    </v-progress-linear>
                </div>
            </template>
        </base-modal>

        <div v-show="computedMaintenancePlanHtml">
            <MaintenancePlanHtml :show="computedMaintenancePlanHtml" :id="computedArrayOfPlanIds.length > 0 ? computedArrayOfPlanIds : computedMaintenancePlanHtmlId" :hasQuotation="true"></MaintenancePlanHtml>
        </div>
        <button id="invisible-button-route" style="display: hidden" @click="checkClickedMenu"></button>

        <div v-show="!computedMaintenancePlanHtml && showTotalizers" class="tables-container">
            <base-page-header :breadcrumb="breadcrumb" :title="titlePage ? titlePage : ''"></base-page-header>
            <v-row v-if="getBudgetStartedByName() != 'active-reception-module' && !this.$route.params.id" class="stepers-row">
                <v-col cols="12" sm="6" class="d-flex  "
                :class="$vuetify.breakpoint.xsOnly ? 'justify-center align-center' : 'align-md-end'">
                    <span v-if="!isPreviewOrEdit" class="text-vehicle">{{vehicleName}} <span v-if="vehiclekW.length > 0"> - {{vehiclekW[0].value}} {{$t('module-budget.main-budget.text-vehicle-kw')}}</span></span>
                    <span v-else class="text-vehicle">{{vehicleInfo}} <span v-if="vehiclekW.length > 0"> - {{vehiclekW[0].value}} {{$t('module-budget.main-budget.text-vehicle-kw')}}</span></span>
                </v-col>
                <v-col cols="12" sm="6">
                    <div v-if="steps && steps.step1 && steps.fields && steps.step2 && steps.step2.response">
                        <div class="stepper">
                            <ul>
                                <li @click="clickChangedStepHeader(1)" class="active">
                                    <span class="line__bottom--step w-50 l-50"></span>
                                    <span class="circle">{{ $t('module-budget.main-budget.step1-number') }}</span>
                                    <span class="text">{{ $t('module-budget.main-budget.step1-text') }}</span>
                                </li>
                                <li @click="clickChangedStepHeader(2)" class="active">
                                    <!-- <span class="line__bottom--step w-50 r-50"></span> -->
                                    <span class="line__bottom--step w-100 r-100 l-100"></span>
                                    <span class="circle">{{ $t('module-budget.main-budget.step2-number') }}</span>
                                    <span class="text">{{ $t('module-budget.main-budget.step2-text') }}</span>
                                </li>
                                <li class="active">
                                    <span class="line__bottom--step w-50 r-50"></span>
                                    <span class="circle">{{ $t('module-budget.main-budget.step3-number') }}</span>
                                    <span class="text">{{ $t('module-budget.main-budget.step3-text') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-else-if="steps == 'showSteppers'">
                        <div class="stepper">
                            <ul>
                                <li @click="clickChangedStepHeader(1)" class="active">
                                    <span class="line__bottom--step w-50 l-50"></span>
                                    <span class="circle">{{ $t('module-budget.main-budget.step1-number') }}</span>
                                    <span class="text">{{ $t('module-budget.main-budget.step1-text') }}</span>
                                </li>
                                <li @click="clickChangedStepHeader(2)" class="active">
                                    <!-- <span class="line__bottom--step w-50 r-50"></span> -->
                                    <span class="line__bottom--step w-100 r-100 l-100"></span>
                                    <span class="circle">{{ $t('module-budget.main-budget.step2-number') }}</span>
                                    <span class="text">{{ $t('module-budget.main-budget.step2-text') }}</span>
                                </li>
                                <li class="active">
                                    <span class="line__bottom--step w-50 r-50"></span>
                                    <span class="circle">{{ $t('module-budget.main-budget.step3-number') }}</span>
                                    <span class="text">{{ $t('module-budget.main-budget.step3-text') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </v-col>
            </v-row>

            <div>
                <!-- Operations -->
                <v-row>
                    <v-col class="overflow-auto">
                        <v-container fluid class="container--fluid--override">
                            <v-row class="container__row--title">
                                <v-col class="container__col--title icons-title p-0" cols="12">
                                    <img src="/images/_SVGs/mao-de-obra.svg" onload="SVGInject(this)" width="50" height="50" />
                                    <h3 class="mao-de-obra">{{$t('module-budget.main-budget.operations.title')}}</h3>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">

                                    <table class="box-table mt-4" v-if="operationsRowReady">
                                        <tr class="tr-box-table">
                                            <th class="referencia">
                                                {{ $t('module-budget.main-budget.operations.th1') }}
                                            </th>
                                            <th class="operacao">
                                                {{ $t('module-budget.main-budget.operations.th2') }}
                                            </th>
                                            <th class="hora">{{ $t('module-budget.main-budget.operations.th3') }}
                                            </th>
                                            <th class="tempo">{{ $t('module-budget.main-budget.operations.th4') }}
                                            </th>
                                            <th class="desc">{{ $t('module-budget.main-budget.operations.th5') }}
                                            </th>
                                            <th class="total">{{ $t('module-budget.main-budget.operations.th6') }}
                                            </th>
                                        </tr>

                                        <operations-row
                                            class="tr__registers"
                                            v-for="(operation, index) in operations"
                                            :rowIndex="index"
                                            :key="operation.workId"
                                            :isPreview="isPreview"
                                            :showServicePlan="operation.kindOfPosition"
                                            :laborValues="operation.hasInactiveLabor ? computedLaborValues : computedLaborValueActive"
                                            :switchCounter="switchCounter"
                                            v-bind="operation"
                                            ref="operationsRow"
                                            @edit-row-clicked-operation="editOpration"
                                            @delete-row-clicked="showModalRemoveOperations"
                                            @change-operation-copy-cart="onChangeOperationRow"
                                        ></operations-row>
                                    </table>
                                </v-col>

                                <v-row>
                                    <v-col cols="12" sm="3">
                                        <v-btn
                                            fab
                                            dark
                                            x-small
                                            color="#1e65d8"
                                            v-if="!isPreview"
                                            @click="onAddOperationClicked"
                                            rounded
                                            class=""
                                            data-cy="add-labor-button-budget"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                        <span v-if="!isPreview" @click="onAddOperationClicked" class="ml-3 btn-span">{{$t('module-budget.main-budget.operations.add-intervention')}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="3" class="text-no-wrap">
                                        <v-btn
                                            fab
                                            dark
                                            x-small
                                            color="#1e65d8"
                                            v-if="!isPreview"
                                            @click="onAddServicePackage"
                                            rounded
                                            class=""
                                            data-cy="add-service-pack-1-button-budget"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                        <span v-if="!isPreview" @click="onAddServicePackage" class="ml-3 btn-span">{{
                                                $t('module-budget.main-budget.service-pack.add-service-pack')
                                            }}</span>
                                    </v-col>
                                </v-row>

                                <v-col cols="12" class="totals-table background-totals-table box-table">
                                    <operations-totals
                                        v-if="computedBudgetSummary.operations.values.length > 0"
                                        :isPreview="isPreview"
                                        :durations="computedBudgetSummary.operations.values.map(row => row.duration)"
                                        :global-discount="globalOperationsDiscount"
                                        :counterFlag="firstRenderOfSummary"
                                        @operationTotalsForTotalizerOE="handleWithOperationTotalsForTotalizerOE"
                                    >
                                    </operations-totals>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <!-- FIM: Operations -->

                <!-- Parts -->
                <v-row>
                    <v-col class="overflow-auto">
                        <v-container fluid class="container--fluid--override">
                            <v-row class="container__row--title">
                                <v-col class="container__col--title p-0 icons-title" cols="12">
                                    <img src="/images/_SVGs/pecas.svg" onload="SVGInject(this)" width="50" height="50" />
                                    <h3>{{$t('module-budget.main-budget.parts.title')}}</h3>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" class="box-table">
                                    <table>
                                        <tr>
                                            <th class="referencia">{{$t('module-budget.main-budget.parts.th1')}}</th>
                                            <th class="brand">{{$t('module-budget.main-budget.parts.th2')}}</th>
                                            <th class="part">{{$t('module-budget.main-budget.parts.th3')}}</th>
                                            <th class="iam" v-if="showIamColumn || enableAllPartsSwitch">

                                            <v-tooltip color="black" bottom >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-on="on" v-bind="attrs" data-cy="all-iam-switch">
                                                        <v-switch
                                                            v-bind="attrs" v-on="on"
                                                            v-model="isAllIam"
                                                            :disabled="disableAllPartsSwitch && !enableAllPartsSwitch"
                                                            hide-details
                                                            color="#4CAA5E"
                                                            dense
                                                            @change="toggleAllIamParts">
                                                        </v-switch>
                                                    </div>
                                                </template>
                                                <span>{{isAllIam ? $t('module-budget.main-budget.parts.span-switch-to-oe') : $t('module-budget.main-budget.parts.span-switch-to-iam')}}</span>
                                            </v-tooltip>

                                            </th>
                                            <th class="price">{{ $t('module-budget.main-budget.parts.th4') }}</th>
                                            <th class="quantity">{{ $t('module-budget.main-budget.parts.th5') }}
                                            </th>
                                            <th class="discount">{{ $t('module-budget.main-budget.parts.th6') }}
                                            </th>
                                            <th class="total">{{ $t('module-budget.main-budget.parts.th7') }}</th>
                                        </tr>

                                        <parts-row
                                            v-for="(part, index) in sortedParts"
                                            class="tr__registers"
                                            ref="partsRow"
                                            :key="index"
                                            :index="part[0].apiPartOrder"
                                            :part="part"
                                            :isPreview="isPreview"
                                            :showIamColumn="showIamColumn"
                                            :isIamWithoutSM="isIamWithoutSM"
                                            :isIam="isIam"
                                            :isPartsTruncate="isPartsTruncate"
                                            @iam-switch-changed="partIamSwitchChanged"
                                            @total-updated="updateTotalOeOnlyValue"
                                            @isCheckedIAM="checkIAM"
                                            @delete-row-clicked-parts="showModalRemovePart"
                                            @edit-row-clicked-parts="showModalEditPart"
                                            @change-selected-part-oe="handleChangeOePartDrop"
                                        ></parts-row>
                                    </table>
                                </v-col>

                                <v-col cols="12" class="text-center" v-if="parts.length == 0">
                                    <small>{{ $t('module-budget.main-budget.parts.non-existent-parts') }}</small>
                                </v-col>

                                <v-row>
                                    <v-col v-if="!isPreview && isSupplier" cols="12" sm="3">
                                        <v-btn
                                            fab
                                            dark
                                            x-small
                                            color="#F59534"
                                            @click="onClickContactSupplier"
                                            rounded
                                            class=""
                                            data-cy="add-labor-button-budget"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                        <span @click="onClickContactSupplier"
                                              class="ml-3 btn-span">{{
                                                $t('request-manager.quotation-summary-contact-supplier')
                                            }}</span>
                                    </v-col>

                                    <v-col cols="12" sm="3">
                                        <v-btn
                                            fab
                                            dark
                                            x-small
                                            color="#1e65d8"
                                            v-if="!isPreview"
                                            @click="onAddPartClicked"
                                            rounded
                                            class=""
                                            data-cy="add-part-button-budget"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                        <span v-if="!isPreview" @click="onAddPartClicked"
                                              class="ml-3 btn-span">{{
                                                $t('module-budget.main-budget.parts.add-part')
                                            }}</span>
                                    </v-col>

                                    <v-col cols="12" sm="3" class="text-no-wrap">
                                        <v-btn
                                            fab
                                            dark
                                            x-small
                                            color="#1e65d8"
                                            v-if="!isPreview"
                                            @click="onAddServicePackage"
                                            rounded
                                            class=""
                                            data-cy="add-service-pack-2-button-budget"
                                        >
                                            <v-icon dark>
                                                mdi-plus
                                            </v-icon>
                                        </v-btn>
                                        <span v-if="!isPreview" @click="onAddServicePackage" class="ml-3 btn-span">{{$t('module-budget.main-budget.service-pack.add-service-pack')}}</span>
                                    </v-col>
                                </v-row>

                                <v-col cols="12" class="totals-table background-totals-table box-table">
                                    <parts-totals
                                        v-if="computedBudgetSummary.parts.values.length > 0"
                                        :isPreview="isPreview"
                                        :global-discount="globalPartsDiscount"
                                        :isIam="computedShowIamTotals"
                                    >
                                    </parts-totals>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <!-- FIM: Parts -->

                <v-row class="justify-space-between">
                    <v-col cols="12" sm="6" :class="{ 'order-2': $vuetify.breakpoint.xsOnly }">
                        <!-- <p class="disclaimer"><small>* O valor respeitante à Eco-Taxa é meramente indicativo e pode variar.</small></p> -->
                        <div class="container--obs">
                            <p>{{ $t('module-budget.main-budget.modal-actions.send-email.obs') }}</p>
                            <v-col cols="12">
                                <v-form v-model="validadeObs">
                                    <v-textarea
                                        v-model="observationsQuotation"
                                        filled
                                        name="input-7-4"
                                        auto-grow
                                        rows="3"
                                        counter="136"
                                        :rules="rules.obsRules"
                                    ></v-textarea>
                                </v-form>
                            </v-col>
                        </div>
                        <div class="button-actions d-block">
                            <v-row>
                                <v-col cols="12" class="div-white-buttons">
                                    <div v-for="button in actionButtons" :key="button.text" class="mr-4">
                                        <base-button
                                            class="d-block btn-action mb-2"
                                            text
                                            height="34"
                                            @click="button.clickEvent"
                                            v-if="button.text == $t('module-budget.main-budget.action-buttons.send-webshop') && isActiveWebShop || button.text != $t('module-budget.main-budget.action-buttons.send-webshop')"
                                        >
                                            <div class="d-flex min-width-100">
                                                <v-icon dense color="primary">
                                                    {{ button.icon }}
                                                </v-icon>
                                                <span class="primary--text font-weight-bold ml-2">
                                                {{ button.text }}
                                            </span>
                                            </div>
                                        </base-button>
                                    </div>

                                </v-col>

                                <v-col v-if="!isPreview" cols="12" class="row-actions-final"
                                       :class="{ 'd-flex flex-column align-center': $vuetify.breakpoint.xsOnly }">
                                    <base-button
                                        rounded
                                        ref="clickSaveModal"
                                        class="btn-color-blue"
                                        :class="{ 'mr-4': $vuetify.breakpoint.smAndUp, 'd-block mt-3': $vuetify.breakpoint.lgAndDown }"
                                        @click="showModal(modal.types.SAVE)"
                                        :disabled="!validadeObs"
                                        data-cy="budget-save-button"
                                    >
                                        <div class="d-flex flex-column justify-center align-center">
                                        <span>
                                            {{ $t('save') }}
                                        </span>
                                            <small>{{ $t('not-done-yet') }}</small>
                                        </div>
                                    </base-button>
                                    <base-button
                                        rounded
                                        class="btn-color-red"
                                        :class="{ 'mr-4': $vuetify.breakpoint.smAndUp, 'd-block mt-3': $vuetify.breakpoint.lgAndDown }"
                                        @click="showModal(modal.types.REJECT)"
                                        data-cy="budget-reject-button"
                                    >
                                        {{$t('reject')}}
                                    </base-button>
                                    <base-button
                                        rounded
                                        class="btn-color-green"
                                        :class="{ 'd-block mt-3': $vuetify.breakpoint.lgAndDown }"
                                        @click="showModal(modal.types.APPROVE)"
                                        :disabled="!validadeObs"
                                        data-cy="budget-approve-button"
                                    >
                                        {{ $t('approve') }}
                                    </base-button>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex"
                           :class="$vuetify.breakpoint.xsOnly ? 'flex-column align-items-center' : 'justify-space-between'">
                        <totalizer
                            v-if="computedCheckRoute && computedShowOeTotals"
                            type="oe"
                            :title="getTotalizerTitle(1)"
                            :totalTitle="getTotalizerTitle(2)"
                            :totalNetOperations="dataOperationTotalsForTotalizerOE"
                            :totalNetParts="computedTotalOeWithDisconts"
                            ref="finalOeTotals"
                        ></totalizer>

                        <totalizer
                            v-if="!computedCheckRoute && computedShowOeTotals"
                            type="oe"
                            :title="getTotalizerTitle(1)"
                            :totalTitle="getTotalizerTitle(2)"
                            :totalNetOperations="dataOperationTotalsForTotalizerOE"
                            :totalNetParts="computedTotalOeWithDisconts"
                            ref="finalOeTotals"
                        ></totalizer>

                        <totalizer
                            v-if="computedShowIamTotals"
                            type="iam"
                            :title="$t('module-budget.main-budget.totalizer-iam.title')"
                            :totalTitle="$t('module-budget.main-budget.totalizer-iam.total-title')"
                            modalCost=1
                            :laborCost="laborCost"
                            :totalNetOperations="computedBudgetSummary.operations.totals.totalWithDiscount"
                            :totalNetParts="computedBudgetSummary.parts.totals.totalWithDiscount"
                            :savingAmount="computedOeVsIamDifference"
                            ref="finalIamTotals"
                        ></totalizer>

                        <totalizer
                            v-if="!computedShowOeTotals && !computedShowIamTotals && showDiagnosticTotalizer"
                            type="oe"
                            :title="$t('module-budget.main-budget.totalizer-diagnostic.title')"
                            :totalTitle="$t('module-budget.main-budget.totalizer-diagnostic.total-title')"
                            :totalNetOperations="computedBudgetSummary.operations.totals.totalWithDiscount ? computedBudgetSummary.operations.totals.totalWithDiscount : 0"
                            :totalNetParts="computedTotalOeWithDisconts"
                            ref="totalDiagnostic"
                        ></totalizer>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- Modal -->
        <v-dialog :persistent="true" v-model="modal.show" max-width="500px">
            <modal-actions
                :showProp="modal.show"
                :type="modal.type"
                :info-type="modal.infoType"
                :obsQuotation="observationsQuotation"
                :businessConditions="businessConditionData"
                @ok-clicked="modalActionClicked"
                @cancel-clicked="cancelModal"
                @info-ok-clicked="modalInfoOkClicked"
                @call-order="modalShowOrder"
                @on-change-obs="handleChangeTheObservations"
            ></modal-actions>
        </v-dialog>
        <!-- Modal -->

        <base-modal :persistent="true" v-model="modalCheckEmptyPart.show" :title="$t('heads-up')" modal-width="560px" @watch-show-value="clickOutsideModalCheckEmptyPart">
            <template v-slot:modal-close>
                <div @click="modalCheckEmptyPart.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{ modalCheckEmptyPart.message }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn color="" class="danger-button" text @click="modalCheckEmptyPart.show = false">
                        {{ $t('no') }}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn color="" text class="primary-button" @click="continueBudget">
                        {{ $t('yes') }}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalRequest.show" :title="$t('heads-up')" modal-width="560px">
            <template v-slot:modal-body>
                {{ modalRequest.message }}
            </template>

            <template v-slot:modal-actions>
                <div></div>
                <div>
                    <v-btn color="" text class="primary-button" @click="onOkModalRequestCliked">
                        {{ $t('ok') }}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal Add Operation or Part-->
        <base-modal :persistent="true" v-model="modalAddOperationOrPart.show"
                    :title="modalAddOperationOrPart.isOperation ? $t('module-budget.main-budget.modal-add-op-or-part.title1') : $t('module-budget.main-budget.modal-add-op-or-part.title2')"
                    max-width="600px" modal-width="400px" @watch-show-value="clickOutsideModalAddOperationOrPart">
            <template v-slot:modal-close>
                <div @click="onCloseAddModal">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>

            <template v-slot:modal-body>
                <p class="mb-2 d-flex justify-center" style="font-size: 16px">
                    {{ $t('module-budget.main-budget.modal-add-op-or-part.choose-options') }}</p>

                <div class="d-flex flex-column align-center">
                    <v-btn @click="onClickToPredefinedOperation" data-cy="add-pre-defined-operation-button" rounded
                           class="primary-button mb-4 mt-2" width="250px">
                        <span
                            style="text-transform: uppercase">{{
                                $t('module-budget.main-budget.modal-add-op-or-part.intervention')
                            }}</span>
                    </v-btn>
                    <v-btn @click="onAddFreePosition" data-cy="add-free-operation-button" rounded
                           class="primary-button" width="200px">
                        <span
                            style="text-transform: uppercase">{{
                                $t('module-budget.main-budget.modal-add-op-or-part.free-position')
                            }}</span>
                    </v-btn>
                </div>
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn text class="danger-button" @click="onCloseAddModal">
                        <span style="text-transform: uppercase">{{ $t('cancel') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>
        <!-- Modal -->

        <!-- Modal Add Operation Form -->
        <base-modal :persistent="true" v-model="modalFreeOperation.show"
                    :title="$t('module-budget.main-budget.modal-add-op-form.title')" modal-width="700px"
                    modalAlign="justify-center" @watch-show-value="clickOutsideModalFreeOperation">
            <template v-slot:modal-close>
                <div @click="onCloseAddModal">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>
            <template v-slot:modal-body>
                <p class="mb-2 d-flex justify-center" style="font-size: 16px">
                    {{ $t('module-budget.main-budget.modal-add-op-form.fill-fields') }}</p>
                <v-form v-model="modalFreeOperation.valid" cols="12" class="d-flex flex-column">
                    <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-column' : 'd-flex flex-row'">
                        <v-col class="mb-4" cols="12" sm="4">
                            <v-text-field
                                v-model="modalFreeOperation.newPosition.reference"
                                type="text"
                                min="0"
                                :label="$t('module-budget.main-budget.modal-add-op-form.ref-label')"
                                outlined
                                dense
                                :rules="[refFreeOperationRules]"
                                data-cy="add-free-operation-reference"
                            ></v-text-field>
                        </v-col>
                        <v-col class="mb-4" cols="12" sm="4">
                            <v-text-field
                                v-model="modalFreeOperation.newPosition.names[0]"
                                :label="$t('module-budget.main-budget.modal-add-op-form.op-label')"
                                outlined
                                dense
                                hide-details
                                :rules="rules.opRules"
                                data-cy="add-free-operation-operation"
                            ></v-text-field>
                        </v-col>
                        <v-col class="mb-4" cols="12" sm="4">
                            <v-menu
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="modalFreeOperation.newPosition.durationComplete"
                                        :label="$t('time')"
                                        append-icon="mdi-clock-outline"
                                        readonly
                                        outlined
                                        dense
                                        v-on="on"
                                        :rules="rules.opRules"
                                        data-cy="add-free-operation-time"
                                    ></v-text-field>
                                </template>
                                <v-time-picker v-model="modalFreeOperation.newPosition.durationComplete"
                                               format="24hr"></v-time-picker>
                            </v-menu>
                        </v-col>
                    </div>
                    <div
                        :class="
                        $vuetify.breakpoint.xsOnly
                            ? 'd-flex flex-column align-center justify-center'
                            : 'd-flex flex-row align-center justify-center'
                    "
                    >

                        <v-col class="mb-4" cols="12" sm="12">
                            <v-text-field
                                v-model="modalFreeOperation.newPosition.description"
                                :label="$t('module-budget.main-budget.modal-add-op-form.obs-label')"
                                outlined
                                dense
                                hide-details
                                data-cy="add-free-operation-description"
                            ></v-text-field>
                        </v-col>

                    </div>
                </v-form>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button" data-cy="add-free-operation-cancel-button" @click="onCloseAddModal">
                        <span style="text-transform: capitalize">{{$t('cancel')}}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn :disabled="modalFreeOperation.valid == false" text class="primary-button" data-cy="add-free-operation-ok-button" @click="onOkClickedFreeOperation">
                        <span style="text-transform: capitalize">{{$t('ok')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>
        <!-- Modal -->

        <!-- Modal Add Part Form-->
        <base-modal :persistent="true" v-model="modalFreePart.show"
                    :title="$t('module-budget.main-budget.modal-add-part-form.title')" modal-width="600px"
                    @watch-show-value="clickOutsideModalFreePart">
            <template v-slot:modal-close>
                <div @click="onCloseAddModal">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>
            <template v-slot:modal-body>
                <div class="d-flex align-center justify-center mb-4">
                    <!-- <v-btn @click="onTypeSearchClicked(1)" rounded :color="modalFreePart.searchMethod === 1 ? 'blue' : '' " width="200px" class="btn-primary-custom">
                    <span style="text-transform: capitalize">{{$t('module-budget.main-budget.modal-add-part-form.search-by-ref')}}</span>
                </v-btn> -->
                    <v-btn v-if="modalFreePart.searchMethod != 2" @click="onTypeSearchClicked(2)" rounded
                           style="min-width: 200px;" class=" ml-3 primary-button">
                        <span style="text-transform: uppercase"
                              data-cy="add-free-part-button">{{
                                $t('module-budget.main-budget.modal-add-part-form.add-free-part-label')
                            }}</span>
                    </v-btn>
                </div>
                <div>
                    <v-form v-model="modalFreePart.valid2" v-if="modalFreePart.searchMethod === 2"
                            class="d-flex flex-column mb-5" cols="12">
                        <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-column' : 'd-flex flex-row'">
                            <v-text-field
                                :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                                v-model="modalFreePart.newPart[0].partNo"
                                type="text"
                                min="0"
                                :label="$t('module-budget.main-budget.modal-add-part-form.ref-label')"
                                outlined
                                dense
                                hide-details
                                :rules="[refFreePartRules]"
                                data-cy="add-part-ref"
                            ></v-text-field>
                            <v-text-field
                                :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                                v-model="modalFreePart.newPart[0].amounts[0].amount"
                                type="number"
                                min="0"
                                :label="$t('module-budget.main-budget.modal-add-part-form.quantity-label')"
                                class="input-number"
                                outlined
                                dense
                                hide-details
                                @keypress="onlyNumberRule"
                                @change="onChangeAmount"
                                :rules="rules.priceRules"
                                data-cy="add-part-quantity"
                            ></v-text-field>
                            <v-text-field
                                v-model="modalFreePart.newPart[0].costPrice"
                                :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                                type="number"
                                min="0"
                                :label="$t('module-budget.main-budget.modal-add-part-form.cost-price-label')"
                                class="input-number"
                                outlined
                                dense
                                hide-details
                                :rules="rules.priceRules"
                                @keypress="onlyNumberRule"
                                @change="onChangeAmountCost(modalFreePart.newPart[0].costPrice, 'costPrice')"
                                data-cy="add-part-costprice"
                            />
                            <v-text-field
                                v-model="modalFreePart.newPart[0].partPrice"
                                type="number"
                                min="0"
                                :label="$t('module-budget.main-budget.modal-add-part-form.sell-price-label')"
                                :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                                class="input-number"
                                outlined
                                dense
                                hide-details
                                :rules="rules.priceRules"
                                @keypress="onlyNumberRule"
                                @change="onChangeAmountCost(modalFreePart.newPart[0].partPrice, 'partPrice')"
                                data-cy="add-part-sellingprice"
                            />
                        </div>
                        <div :class="$vuetify.breakpoint.xsOnly ? '' : 'mt-2'">
                            <v-text-field
                                :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                                v-model="modalFreePart.newPart[0].itemMpText"
                                type="text"
                                min="0"
                                :label="$t('module-budget.main-budget.modal-add-part-form.desc-label')"
                                outlined
                                dense
                                hide-details
                                :rules="rules.opRules"
                                data-cy="add-part-description"
                            ></v-text-field>
                        </div>
                    </v-form>
                    <div v-if="modalFreePart.searchMethod === 1">
                        <p class="mb-2 d-flex justify-center" style="font-size: 16px">
                            {{ $t('module-budget.main-budget.modal-add-part-form.search-by-ref') }}</p>
                        <v-card-text class="d-flex flex-column align-center">
                            <v-form>
                                <div class="mb-4 ml-9 d-flex flex-row">
                                    <v-text-field
                                        v-model="modalFreePart.referenceSearch"
                                        type="text"
                                        min="0"
                                        :label="$t('module-budget.main-budget.modal-add-part-form.ref-label')"
                                        outlined
                                        dense
                                        hide-details
                                        :rules="rules.refRules"
                                    ></v-text-field>
                                    <v-btn icon color="var(--v-primary-base)"
                                           @click="searchPartByReference(modalFreePart.referenceSearch)">
                                        <img
                                            aria-hidden="true"
                                            src="/images/_SVGs/magnify-blue.svg"
                                            onload="SVGInject(this)"
                                        />
                                    </v-btn>
                                </div>
                                <div class="ml-4" v-show="modalFreePart.notFound">
                                    <span style="color: red">{{$t('module-budget.main-budget.modal-add-part-form.not-found')}}</span>
                                </div>
                                <div class="ml-4" v-show="modalFreePart.isExists">
                                    <span style="color: red">{{$t('module-budget.main-budget.modal-add-part-form.exists')}}</span>
                                </div>
                                <div class="ml-4" v-show="modalFreePart.foundPart.show">
                                    <span style="color: green">{{ modalFreePart.foundPart.message }}</span>
                                </div>
                                <div class="ml-10" v-show="modalFreePart.loading">
                                    <span style="color: black">{{$t('module-budget.main-budget.modal-add-part-form.loading')}}</span>
                                </div>
                            </v-form>


                        </v-card-text>
                    </div>
                    <div class="text-center">
                        <v-btn @click="onClickToPredefinedOperation" rounded text width="200px">
                            <span
                                style="text-transform: capitalize"><u>{{
                                    $t('module-budget.main-budget.modal-add-part-form.graphic-label')
                                }}</u></span>
                        </v-btn>
                    </div>
                </div>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button" @click="onCloseAddModal">
                        <span style="text-transform: uppercase">{{ $t('cancel') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn v-if="modalFreePart.searchMethod !== 2" :disabled="modalFreePart.valid == false" text class="primary-button" @click="onOkClickedFreePart">
                        <span style="text-transform: uppercase">{{$t('module-budget.main-budget.modal-add-part-form.add-part')}}</span>
                    </v-btn>
                    <v-btn v-if="modalFreePart.searchMethod === 2" :disabled="modalFreePart.valid2 == false" text class="primary-button" @click="onOkClickedFreePart">
                        <span data-cy="add-free-part-button" style="text-transform: uppercase">{{$t('module-budget.main-budget.modal-add-part-form.add-part')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>
        <!-- Modal -->

        <!-- Modal Order-->
        <base-modal :persistent="true" v-model="showModalOrder.show"
                    :title="$t('module-budget.main-budget.modal-order.title')" modal-width="1000px">
            <template v-slot:modal-close>
                <div @click="closeOrderModalRequestCliked()">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>
            <template v-slot:modal-body>
                <v-row v-if="!computedCheckWebshop && (!isEmailDisabled || emailExists)"
                       style="margin-left: 46px; margin-bottom: 10px;">
                    <v-col cols="10" class="d-flex flex-row mt-2 justify-center align-center">
                        <span class="mr-4">{{ $t('order-modal-email-title') }}:</span>
                        <v-text-field
                            v-model="orderIamEmail"
                            :disabled="isEmailDisabled"
                            filled
                            hide-details
                            :rules="rulesEmail"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <div class="d-flex flex-column align-center">
                    <div class="table-container">
                        <v-data-table
                            :headers="orderHeaders"
                            :items="showModalOrder.parts"
                            item-key="itemMpId"
                            v-model="selectedOrderParts"
                            disable-pagination
                            hide-default-footer
                            :single-select="false"
                            show-select
                            mobile
                            dense
                            fixed-header
                            calculate-widths
                        >

                            <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
                                <v-simple-checkbox
                                    :value="isSelected"
                                    @input="select($event)"
                                ></v-simple-checkbox>
                            </template>

                            <template v-slot:[`item.reference`]="{ item }">
                                <span v-if="!item.workId">{{ item.reference }}</span>
                                <span v-else-if="isPartsTruncate">{{ $globals.TRUNCATED_TEXT }}</span>
                                <span v-else>{{ item.reference }}</span>
                            </template>
                            <template v-slot:[`item.referenceOE`]="{ item }">
                                <span v-if="isPartsTruncate">{{ $globals.TRUNCATED_TEXT }}</span>
                                <span v-else>{{ item.referenceOE }}</span>
                            </template>
                            <template v-slot:[`item.referenceIAM`]="{ item }">
                                <span v-if="isPartsTruncate">{{ $globals.TRUNCATED_TEXT }}</span>
                                <span v-else>{{ item.referenceIAM }}</span>
                            </template>

                            <template v-slot:[`item.isIam`]="{ item }">
                                <span>{{ item.isIam ? 'IAM' : 'OE' }}</span>
                            </template>

                            <template v-slot:[`item.brand`]="{ item }">
                                <span>{{ item.brand ? item.brand : computedBrandOfVehicle }}</span>
                            </template>

                            <template v-slot:[`item.quantity`]="{ item }">
                                <div class="mt-3">
                                    <v-text-field
                                        v-if="checkIfFluid(item)"
                                        v-model="item.qtd"
                                        type="number"
                                        class="input-number"
                                        @keypress="onlyNumberRule"
                                        :label="$t('module-budget.main-budget.modal-order.quantity-label')"
                                        outlined
                                        dense
                                        :rules="ruleQuantityOrderFluid"
                                    ></v-text-field>
                                    <v-text-field
                                        v-else
                                        v-model="item.qtd"
                                        type="number"
                                        class="input-number"
                                        @keypress="onlyNumberRule2"
                                        :label="$t('module-budget.main-budget.modal-order.quantity-label')"
                                        outlined
                                        dense
                                        :rules="ruleQuantityOrderNormal"
                                    ></v-text-field>
                                </div>
                            </template>

                        </v-data-table>
                    </div>
                </div>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button" @click="closeOrderModalRequestCliked()">
                        <span style="text-transform: capitalize">{{ $t('exit') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn :disabled="selectedOrderParts.length === 0" rounded class="primary-button"
                           @click="modalActionClicked(showModalOrder.quotation)">
                        <span
                            style="text-transform: capitalize">{{
                                $t('module-budget.main-budget.modal-order.order')
                            }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- Modal -->
        <base-modal :persistent="true" v-model="modalLaborValues.show" :title="$t('heads-up')" modal-width="560px">
            <template v-slot:modal-close>
                <div @click="onDoesNotAcceptInactiveLabor">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>

            <template v-slot:modal-body>
                <span>{{ $t('module-budget.main-budget.modal-labor-values.main-span') }}</span>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="onDoesNotAcceptInactiveLabor">
                        {{ $t('no') }}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="onAcceptInactiveLabor">
                        {{ $t('yes') }}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <!-- <v-speed-dial
        v-show="showTotalizers"
        class="v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--fixed v-btn--has-bg v-btn--right v-btn--round theme--light "
        style="float: right; position: fixed; margin-bottom: 30px;"
        v-model="floatBtn.show"
        :top="false"
        :bottom="false"
        :right="false"
        :left="false"
        :direction="floatBtn.direction"
        :open-on-hover="floatBtn.hover"
        :transition="floatBtn.transition"
    >
        <template v-slot:activator>
            <v-btn v-model="floatBtn.show" color="var(--v-primary-base)" dark fab>
            <v-icon v-if="floatBtn.show">mdi-close</v-icon>
            <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
        </template>
        <v-tooltip bottom v-if="!hasInvoice">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="checkRouteName === 0" fab dark small color="var(--v-primary-base)" @click="onClickToEdit" v-bind="attrs" v-on="on">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
                <span>{{$t('module-budget.main-budget.float-buttons.edit-budget')}}</span>
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small color="var(--v-primary-base)" @click="modalAskForSave.show = true" v-bind="attrs" v-on="on">
                    <v-icon>mdi-clipboard-text</v-icon>
                </v-btn>
            </template>
                <span>{{$t('module-budget.main-budget.float-buttons.new-budget')}}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="computedCheckForPlanningModule">
            <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small color="var(--v-primary-base)" @click="modalGoToPlanning.show = true" v-bind="attrs" v-on="on">
                    <v-icon>mdi-calendar-clock</v-icon>
                </v-btn>
            </template>
                <span>{{$t('module-budget.main-budget.float-buttons.new-planning')}}</span>
        </v-tooltip>
    </v-speed-dial> -->

        <base-modal :persistent="true" v-model="modalAskForSave.show"
                    :title="$t('module-budget.main-budget.modal-ask-for-save.title')" modal-width="560px">
            <template v-slot:modal-close>
                <div @click="modalAskForSave.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>
            <template v-slot:modal-body>
                {{ modalAskForSave.message }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn color="" class="danger-button" text @click="onClickedOnNoOption">
                        <span style="text-transform: capitalize">{{ $t('no') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="onClickToSave">
                        <span style="text-transform: capitalize">{{ $t('yes') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalAlertRemove.show" :title="$t('heads-up')" modal-width="560px"
                    @watch-show-value="clickOutsideModalRemove">
            <template v-slot:modal-close>
                <div @click="cancelRemovePart">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>

            <template v-slot:modal-body>
                {{ $t('module-budget.main-budget.modal-alert-remove.message') }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn data-cy="delete-parts-no-button" text class="danger-button" @click="cancelRemovePart">
                        <span style="text-transform: capitalize">{{ $t('no') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn data-cy="delete-parts-yes-button" text class="primary-button"
                           @click="deletePartsClicked">
                        <span style="text-transform: capitalize">{{ $t('yes') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalAlertRemoveOperations.show" :title="$t('heads-up')"
                    modal-width="560px">
            <template v-slot:modal-close>
                <div @click="cancelRemoveOperations">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>

            <template v-slot:modal-body>
                {{
                    getCartOpsLength() == 1 ? $t('module-budget.main-budget.modal-remove-op.message-last') : $t('module-budget.main-budget.modal-remove-op.message')
                }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button" data-cy="delete-operations-yes-button"
                           @click="cancelRemoveOperations">
                        <span style="text-transform: capitalize">{{ $t('no') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" data-cy="delete-operations-cancel-button"
                           @click="deleteOperationClicked">
                        <span style="text-transform: capitalize">{{ $t('yes') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalAlertAlterPlate.show" :title="$t('heads-up')"
                    modal-width="560px">
            <template v-slot:modal-close>
                <div @click="modalAlertAlterPlate.show = false">
                    <img
                        src="/images/_SVGs/environmental/fechar.svg"
                        onload="SVGInject(this)"
                        width="20"
                        height="20"
                    />
                </div>
            </template>

            <template v-slot:modal-body>
                {{ $t('module-budget.main-budget.modal-alter-plate.message') }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button" @click="noSaveOrder">
                        <span style="text-transform: capitalize">{{ $t('no') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="yesSaveOrder">
                        <span style="text-transform: capitalize">{{ $t('yes') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalAlertToLeave.show" :title="$t('heads-up')" modal-width="560px"
                    @watch-show-value="clickOutsideFunc">
            <template v-slot:modal-close>
                <div @click="modalAlertToLeave.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>

            <template v-slot:modal-body>
                {{ $t('module-budget.main-budget.modal-alert-leave.message') }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn text class="danger-button" @click="onDontSaveBudget">
                        <span style="text-transform: capitalize">{{ $t('backoffice.actions.cancel') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn text class="primary-button" @click="onSaveBudget">
                        <span style="text-transform: capitalize">{{ $t('backoffice.actions.finalize') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalEditPart.show"
                    :title="$t('module-budget.main-budget.modal-edit-part.title')" modal-width="560px">
            <template v-slot:modal-close>
                <div @click="onCancelEditPart">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>
            <template v-slot:modal-body v-if="editPart.reference">
                <v-form v-model="modalEditPart.formValidate" class="d-flex flex-column mb-5 mt-3" cols="12">
                    <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-column' : 'd-flex flex-row'">
                        <v-text-field
                            :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                            v-model="editPart.reference"
                            type="text"
                            min="0"
                            :label="$t('module-budget.main-budget.modal-edit-part.reference-label')"
                            outlined
                            dense
                            hide-details
                            :rules="rules.refRules"
                        ></v-text-field>
                        <v-text-field
                            :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                            v-model="editPart.quantities[0].quantity"
                            type="number"
                            min="0"
                            :label="$t('module-budget.main-budget.modal-edit-part.quantity-label')"
                            class="input-number"
                            outlined
                            dense
                            hide-details
                            :rules="rules.required"
                            @keypress="onlyNumberRule"
                            @change="onChangeAmount"
                        ></v-text-field>
                        <v-text-field
                            v-model="editPart.costPrice"
                            :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : 'mr-2'"
                            type="number"
                            min="0"
                            :label="$t('module-budget.main-budget.modal-edit-part.cost-price-label')"
                            class="input-number"
                            outlined
                            dense
                            hide-details
                            :rules="rules.priceRules"
                            @keypress="onlyNumberRule"
                            @change="onChangeAmountCost"
                        />
                        <v-text-field
                            v-model="editPart.price"
                            type="number"
                            min="0"
                            :label="$t('module-budget.main-budget.modal-edit-part.sell-price-label')"
                            class="input-number"
                            outlined
                            dense
                            hide-details
                            :rules="rules.priceRules"
                            @keypress="onlyNumberRule"
                            @change="onChangeAmountCost"
                        />
                    </div>
                    <div :class="$vuetify.breakpoint.xsOnly ? '' : 'mt-3'">
                        <v-text-field
                            :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : ''"
                            v-model="editPart.name"
                            type="text"
                            min="0"
                            :label="$t('module-budget.main-budget.modal-edit-part.description-label')"
                            outlined
                            dense
                            hide-details
                            :rules="rules.opRules"
                        ></v-text-field>
                    </div>
                </v-form>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="onCancelEditPart">
                        {{ $t('cancel') }}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="onSaveEditPart"
                           :disabled="!modalEditPart.formValidate">
                        {{ $t('save') }}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalEditOperations.show"
                    :title="$t('module-budget.main-budget.modal-edit-op.title')" modal-width="600px">
            <template v-slot:modal-body v-if="editOperation.reference">

                <v-form v-model="modalEditOperations.formValidate"
                        :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-column' : 'd-flex flex-column'"
                        class="mb-5" cols="12">
                    <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-column' : 'd-flex flex-row'">
                        <v-col class="mb-4" cols="12" sm="4">
                            <v-text-field
                                v-model="editOperation.reference"
                                type="text"
                                min="0"
                                :label="$t('module-budget.main-budget.modal-edit-op.reference-label')"
                                outlined
                                dense
                                hide-details
                                :rules="rules.refRules"
                            ></v-text-field>
                        </v-col>
                        <v-col class="mb-4" cols="12" sm="4">
                            <v-text-field
                                v-model="editOperation.names[0]"
                                :label="$t('module-budget.main-budget.modal-edit-op.op-label')"
                                outlined
                                dense
                                hide-details
                                :rules="rules.opRules"
                            ></v-text-field>
                        </v-col>
                        <v-col class="mb-4" cols="12" sm="4">
                            <v-menu
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="editOperation.durationComplete"
                                        :label="$t('time')"
                                        append-icon="mdi-clock-outline"
                                        readonly
                                        outlined
                                        dense
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker v-model="editOperation.durationComplete"
                                               format="24hr"></v-time-picker>
                            </v-menu>
                        </v-col>
                    </div>
                    <div class="d-flex flex-column align-center justify-center">

                        <v-col class="mb-4" cols="12" sm="12">
                            <v-text-field
                                v-model="editOperation.observations"
                                :label="$t('module-budget.main-budget.modal-edit-op.obs-label')"
                                outlined
                                dense
                                hide-details
                            ></v-text-field>
                        </v-col>

                    </div>
                </v-form>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="onCancelEditOperations">
                        {{ $t('cancel') }}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="onSaveEditOperations"
                           :disabled="!modalEditOperations.formValidate">
                        {{ $t('save') }}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalGoToPlanning.show"
                    :title="$t('module-budget.main-budget.modal-go-plan.title')" modal-width="560px"
                    @watch-show-value="clickOutsideModalGoToPlanning">
            <template v-slot:modal-close>
                <div @click="modalGoToPlanning.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20"
                         height="20"/>
                </div>
            </template>
            <template v-slot:modal-body>
                {{ $t('module-budget.main-budget.modal-go-plan.message') }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn color="" class="danger-button" text @click="onRejectSaveToPlanning">
                        <span data-cy="no-schedule-after-budget"
                              style="text-transform: capitalize">{{ $t('no') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="onClickToSaveSchedulingModal"
                           data-cy="yes-schedule-after-budget">
                        <span style="text-transform: capitalize">{{ $t('yes') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalAskForPlanning.show" :title="modalAskForPlanning.title"
                    modal-width="360px" @watch-show-value="clickOutsideAskForPlanning">
            <template v-slot:modal-body>
                {{ modalAskForPlanning.message }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn color="" class="danger-button" text @click="onRejectGoToPlanning">
                        <span style="text-transform: capitalize">{{ $t('no') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="onGoToPlanning">
                        <span style="text-transform: capitalize">{{ $t('yes') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal :persistent="true" v-model="modalAskForStayOnThePage.show"
                    :title="$t('module-budget.main-budget.modal-ask-for-stay.title')" modal-width="360px"
                    @watch-show-value="clickOutsideModalAskForStay">
            <template v-slot:modal-body>
                {{ $t('module-budget.main-budget.modal-ask-for-stay.message') }}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn color="" class="danger-button" text @click="onRejectToStay">
                        <span style="text-transform: capitalize">{{ $t('no') }}</span>
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="modalAskForStayOnThePage.show = false">
                        <span style="text-transform: capitalize">{{ $t('yes') }}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <ServicePack
            v-if="showPacksListFlag"
            :showPacksList="showPacksList"
            @show-packs-list-changed="showPacksListMethod"
            @package-services-transformed="handleGetPackageServicesTransformed"
        />

        <ContactSupplierModal
            :showContactSupplierModal="modalContactSupplier.show"
            :parts="modalContactSupplier.parts"
            @close-modal="modalContactSupplier.show = false"
            @save-quotation="(callback, hasQuotationId) => sendBudgetDataToBackend({ quotationStatusId: '3'}, callback, hasQuotationId)"
        />
    </div>
</transition>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {
    QuotationServicesDownloadIamRequest,
    QuotationServicesGetAdditionalMaintenanceParts,
    QuotationServicesGetClientInformation,
    QuotationServicesGetData,
    QuotationServicesGetEstimateInternalData,
    QuotationServicesGetQuotation,
    QuotationServicesGetWebShop,
    QuotationServicesOrderParts,
    QuotationServicesSendBudgetInfo,
    QuotationServicesSendEmailAndPDF,
} from '@services/b2b/quotation/QuotationServices.js';
import {UserServicesGetBusinessConditions} from '@services/UserServices';
import {EntityServicesGetEntityContactPart} from '@services/backoffice/Entities/EntityServices'
import {modalTypes} from '@components/b2b/budget/modal-actions/types.js';
import OperationsRow from '@components/b2b/budget/operations/OperationsRow.vue';
import OperationsTotals from '@components/b2b/budget/operations/OperationsTotals.vue';
import PartsRow from '@components/b2b/budget/parts/PartsRow.vue';
import PartsTotals from '@components/b2b/budget/parts/PartsTotals.vue';
import Totalizer from '@components/b2b/budget/totalizers/Totalizer.vue';
import {isEmail, maxLength, minLength, required} from '@src/utils/validations.js';
import _ from 'lodash';
import mixinVehicleIdentification from "@mixins/b2b/vehicleIdentification";
import {RequestManagerServicesIsEntitySupplier} from "@services/b2b/request-manager/RequestManagerServices";
import BaseModal from "@components/shared/widgets/BaseModal.vue";
import BaseButton from "@components/shared/widgets/BaseButton.vue";
import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";

export default {
    components: {
        BasePageHeader,
        BaseButton,
        BaseModal,
        OperationsRow,
        OperationsTotals,
        PartsRow,
        PartsTotals,
        Totalizer,
        MaintenancePlanHtml: () => import('@components/b2b/budget/MaintenancePlanHtml'),
        ModalActions: () => import('@components/b2b/budget/modal-actions/ModalActions.vue'),
        ServicePack: () => import('@components/b2b/budget/servicePacks/ServicePack.vue'),
        ContactSupplierModal: () => import("@components/b2b/budget/contactSupplierModal/ContactSupplierModal.vue")
    },
    props: {
        // this prop should come from the route itself
        isPreview: {
            type: Boolean
        }
    },
    mixins: [mixinVehicleIdentification],
    data() {
        return {
            isSupplier: false,
            isReady: true,
            showDiagnosticTotalizer: false,

            breadcrumb: [
                {
                    title: this.$t('module-budget.main-budget.breadcrumb.budgets'),
                    routerLinkName: 'budget'
                },
                {
                    title: this.$t('module-budget.main-budget.breadcrumb.next-revision'),
                }
            ],

            titlePage: this.$t('module-budget.main-budget.breadcrumb.title-page'),

            modalAlertAlterPlate: {
                show: false
            },

            floatBtn: {
                direction: 'top',
                show: false,
                hover: false,
                transition: 'slide-y-reverse-transition',
            },

            modalAskForSave: {
                show: false,
                message: this.$t('module-budget.main-budget.modal-ask-for-save.message')
            },

            globalOperationsDiscount: 0,
            globalPartsDiscount: 0,
            operations: [],
            parts: {},
            isAllIam: false,
            hasAnyIamSelected: false,

            tempOperations: null,
            tempParts: null,

            actionButtons: [
                {
                    text: this.$t('module-budget.main-budget.action-buttons.print'),
                    icon: 'mdi-printer',
                    clickEvent: this.printClicked
                },
                {
                    text: this.$t('module-budget.main-budget.action-buttons.send-email'),
                    icon: 'mdi-email-outline',
                    clickEvent: this.sendEmailClicked
                },
            ],

            modal: {
                show: false,
                type: '',
                infoType: null,
                types: {
                    ...modalTypes
                }
            },

            modalRequest: {
                show: false,
                message: this.$t('module-budget.main-budget.modal-request.message')
            },

            modalAddOperationOrPart: {
                isOperation: false,
                isPart: false,
                show: false,
                addOperationOrPart: false
            },

            modalFreeOperation: {
                show: false,
                valid: false,
                newPosition: {
                    discount: 0,
                    duration: {hours: '', minutes: ''},
                    hourValue: {},
                    itemMpId: '',
                    names: [''],
                    freeReference: true,
                    reference: '',
                    singleWorkTime: 0,
                    totalWorkTime: 0,
                    workId: '',
                    workPosDescription: '',
                    workPosCriteriaDescription: '',
                    workTime: 0,
                    description: '',
                    calculatedTime: 0,
                    inclusiveWorkPositions: [],
                    durationComplete: '',
                    hourValueDefault: {oe: {}, iam: {}}
                }
            },

            modalFreePart: {
                show: false,
                valid: false,
                valid2: false,
                referenceSearch: '',
                notFound: false,
                isExists: false,
                loading: false,
                foundPart: {
                    show: false,
                    message: ''
                },
                newPart: [{
                    partNo: '',
                    itemMpText: '',
                    tips4yQuantity: 1,
                    partPrice: '0.00',
                    costPrice: '0.00',
                    amounts: [{
                        amount: '',
                        isOnlyForReference: false,
                        itemMpId: 0,
                        qualColId: 0,
                        quantity: ""
                    }],
                    iamParts: [],
                    itemMpId: '',
                    freeReference: true,
                }],
                searchMethod: 0,
            },

            rules: {
                refRules: [required, maxLength(20)],
                opRules: [required],
                hourRules: [required, maxLength(2)],
                minuteRules: [required, maxLength(2)],
                descRules: [required, maxLength(3)],
                priceRules: [required, minLength(1)],
                obsRules: [v => !v || v && v.length === 0 || v && v.length <= 136 || this.$t('module-budget.main-budget.modal-actions.send-email.obs-rules')],
            },

            showModalOrder: {
                show: false,
                parts: '',
                quotation: {
                    quotationStatusId: 1
                }
            },

            orderHeaders: [
                {text: this.$t('refoe'), value: 'referenceOE', align: 'start', sortable: false},
                {text: this.$t('refiam'), value: 'referenceIAM', align: 'start', sortable: false},
                {text: this.$t('selection'), value: 'isIam', align: 'start', sortable: false},
                {
                    text: this.$t('module-budget.main-budget.modal-order.order-headers.brand'),
                    value: 'brand',
                    align: 'start',
                    sortable: false,
                    width: '18%'
                },
                {
                    text: this.$t('module-budget.main-budget.modal-order.order-headers.part-name'),
                    value: 'name',
                    align: 'start',
                    sortable: false
                },
                {text: '', value: 'quantity', align: 'start', sortable: false, width: '12%'}
            ],
            budgetSummaryPartsClone: '',
            selectedOrderParts: [],
            temporaryIdForOrder: null,

            modalCheckEmptyPart: {
                show: false,
                message: this.$t('module-budget.main-budget.modal-empty-card.message'),
                count: 0,
            },

            allLaborValues: '',

            firstRenderOperations: 0,
            firstRenderParts: 0,
            isCheckedIAM: false,

            modalLaborValues: {
                show: false,
                findDifferenceLaborInactive: []
            },

            operationsRowReady: true,

            modalAlertRemove: {
                show: false
            },
            removePart: [],

            modalAlertRemoveOperations: {
                show: false
            },
            removeOperations: [],
            vehicle: [],
            edit: false,
            newPlate: null,

            modalAlertToLeave: {
                show: false,
                needToRedirect: false,
            },
            modalEditPart: {
                show: false,
                formValidate: true
            },
            modalEditOperations: {
                show: false,
                formValidate: true
            },
            editPart: [],
            editOperation: [],
            carName: null,
            allCalcIamCost: [],
            vehicleInfo: '',
            isPreviewOrEdit: false,

            modalGoToPlanning: {
                show: false,
                message: '',
                goToPlanning: false
            },
            routeName: null,
            newQuotationId: null,

            modalAskForPlanning: {
                show: false,
                message: '',
                title: this.$t('module-budget.main-budget.modal-ask-plan.title1'),
                id: null
            },

            modalAskForStayOnThePage: {
                show: false,
            },

            responsePDF: null,
            kmBudget: null,
            notParts: false,

            showTotalizers: true,
            hasInvoice: false,

            catchError: false,

            hasPlanningId: null,

            progressBar: {
                show: false,
                percentage: 20,
                visualMessage: '',
                isLooping: false,
                showMessage: true,
                messages: [
                    this.$t('module-budget.main-budget.loading.messages.message1'),
                    this.$t('module-budget.main-budget.loading.messages.message2'),
                    this.$t('module-budget.main-budget.loading.messages.message3'),
                    this.$t('module-budget.main-budget.loading.messages.message4'),
                    this.$t('module-budget.main-budget.loading.messages.message5'),
                ]
            },

            showPacksList: false,
            showPacksListFlag: false,

            sendEmail: false,

            rejectedQuotation: false,

            switchCounter: 0,

            observationsQuotation: "",
            removeOperationByEntityServicePackageId: '',

            businessConditionData: [],
            isPartsTruncate: false,

            validadeObs: false,

            orderIamEmail: '',

            rulesEmail: [v => !!v || this.$t('required-input'), v => isEmail(v) || this.$t('email-validate-input')],

            hasIamQuotationBusinessConditionActive: false,

            firstRenderOfSummary: 1,

            netDataOperations: 0,

            sortedParts: [],

            datePickerHourConfig: false,

            isEmailDisabled: false,

            emailExists: false,

            ruleQuantityOrderNormal: [required, maxLength(2)],
            ruleQuantityOrderFluid: [required, maxLength(5)],
            dataOperationTotalsForTotalizerOE: 0,

            modalContactSupplier: {
                show: false,
                parts: [],
            }
        };
    },
    computed: {
        disableAllPartsSwitch() {
            return (this.isPreview || !this.isCheckedIAM);
        },
        enableAllPartsSwitch() {
            return !this.isIam && !this.isIamWithoutSM && this.checkIfAnyFluid;
        },
        checkIfAnyFluid() {
            let anyFluid = false;
            let parts = _.cloneDeep(this.sortedParts);
            if (parts.length > 0) {
                parts.forEach(part => {
                    let selectedPart = part.find((part) => part.isSelected);
                    if (!selectedPart) {
                        selectedPart = part[0];
                    }
                    selectedPart.quantity = selectedPart.quantities[0].quantity;
                    if (this.checkIfFluid(selectedPart) && !this.checkIfIsEcolub(selectedPart) && selectedPart.iamParts && selectedPart.iamParts.length > 0) {
                        anyFluid = true;
                    }
                })
            }
            return anyFluid;
        },
        isIam() {
            if (this.businessConditionData.length > 0) {
                let isIam = this.businessConditionData.find(o => o.businessConditionID == this.$globals.BUSINESS_CONDITION.IAM);
                return isIam.isSelected;
            }
            return false;
        },
        isIamWithoutSM() {
            if (this.businessConditionData.length > 0) {
                let isIamWithoutSM = this.businessConditionData.find(o => o.businessConditionID == this.$globals.BUSINESS_CONDITION.IAM_WITHOUT_SM);
                if (isIamWithoutSM) {
                    return isIamWithoutSM.isSelected;
                } else {
                    return false;
                }
            }
            return false;
        },
        showIamColumn() {
            return this.isIam || this.isIamWithoutSM || this.checkIfAnyFluid;
        },
        ...mapState('budget', {
            computedChangedShoppingCart: state => state.b2b.shoppingCart.numberOfChanges, // a funny way that was found to detect if the shopping cart changed. should've been just a store watch though
            computedCurrentShoppingCart: state => state.b2b.shoppingCart,
            computedMaintenancePlanHtml: state => state.b2b.maintenancePlanHtml.show,
            computedMaintenancePlanHtmlId: state => state.b2b.maintenancePlanHtml.id,
            computedBudgetSummary: state => state.b2b.budgetSummary,
            computedStateForCalcs: state => state.b2b.budgetSummary.stateForTotalizersCalcsOeTotals
        }),
        ...mapGetters({
            computedFavouriteLaborValue: 'budget/getB2bFavouriteLaborValue',
            computedCurrentShoppingCart: 'budget/getB2bCurrentShoppingCart'
        }),
        steps() {
            const getStep1 = this.$store.getters['budget/getB2bStep1'];
            const getStep2 = this.$store.getters['budget/getB2bStep2'];
            if (getStep1 && getStep1.fields && getStep2 && getStep2.response) {
                return 'showSteppers'
            } else {
                return JSON.parse(localStorage.getItem('budgetB2b'))
            }
        },
        vehiclekW() {
            if (this.$store.getters['vehicleIdentification/getState'].plateNumber) {
                const power_kW = this.$store.getters['vehicleIdentification/getState'].data.filter(el => el.description == 'Power_kW');
                return power_kW ? power_kW : [];
            } else {
                return [];
            }
        },
        vehicleName() {
            return this.$store.getters['vehicleIdentification/controlDetails']
        },
        computedOeVsIamDifference() {
            return this.computedBudgetSummary.totals.oe.total - this.computedBudgetSummary.totals.iam.total;
        },
        computedShowOeTotals() {
            /*if(this.computedBudgetSummary.parts.totals.totalOeOnlyWithDiscount !== NaN && this.computedBudgetSummary.parts.totals.totalOeOnlyWithDiscount !== 0) {
                return (
                this.computedBudgetSummary.operations.totals.totalWithDiscount &&
                this.computedBudgetSummary.parts.totals.totalOeOnlyWithDiscount
            );
            } else {
                return (
                    this.computedBudgetSummary.operations.totals.totalWithDiscount
                );
            }*/

            return this.computedBudgetSummary.operations.totals.totalWithDiscount != undefined && this.computedBudgetSummary.parts.totals.totalWithDiscount != undefined;
        },
        computedTotalOeWithoutDiscount() {
            if (this.hasAnyIamPart) {
                const totalInCents = this.$store.state.budget.b2b.budgetSummary.parts.values.reduce((acc, row) => {
                    if (!isNaN(row.totalWithoutVAT)) {
                        return acc + Math.round(row.totalWithoutVAT * 100);
                    } else {
                        return acc;
                    }
                }, 0);
                return totalInCents / 100;
            }
            return this.$store.state.budget.b2b.budgetSummary.parts.totals.totalOeOnlyWithDiscount;
        },
        computedTotalOeWithDisconts() {
            return this.computedBudgetSummary.parts.totals.globalDiscount > 0
                ? this.computedTotalOeWithoutDiscount * (1 - this.computedBudgetSummary.parts.totals.globalDiscount / 100)
                : this.computedTotalOeWithoutDiscount;
        },
        computedShowIamTotals() {
            return (
                this.hasAnyIamSelected
            );
        },
        computedOperations() {
            return this.$store.getters['budget/getStateB2b'].budgetSummary.operations;
        },
        computedLastBudget() {
            return this.$store.getters['budget/getLastBudgetSelectedEditToCompare'];
        },
        computedNewBudgetToCompare() {
            return this.$store.getters['budget/getNewBudgetToCompare'];
        },
        computedBrandOfVehicle() {
            const getVehicleState = this.$store.getters['vehicleIdentification/getState'].data;
            const findMakeParam = getVehicleState.find(element => element.description == 'Make');
            if (findMakeParam) {
                return findMakeParam.value;
            }
            return '';
        },
        checkRouteName() {
            return ['budget-summary-preview', 'budget-summary-edit'].indexOf(this.$route.name);
        },
        computedLaborValues() {
            let labor = this.$store.getters['budget/getB2bLaborValues'];
            if (this.hasAnyIamSelected) {
                labor = labor.filter(e => e.isIAM);
            } else {
                labor = labor.filter(e => !e.isIAM);
            }
            return labor;
        },
        computedLaborValueActive() {
            let labor = this.$store.getters['budget/getB2bLaborValues'];
            labor = labor.filter(el => el.isActive === true);
            if (this.hasAnyIamSelected) {
                labor = labor.filter(e => e.isIAM);
            } else {
                labor = labor.filter(e => !e.isIAM);
            }
            return labor;
        },
        isActiveWebShop() {
            const isActive = this.$store.getters['auth/getState'].modules.filter(el => el.moduleId == 7).map(m => m.isActive)
            return isActive[0]
        },
        checkBudgetStartedBy() {
            let checkLSQuotationType = JSON.parse(localStorage.getItem('@datadrive:budgetQuotationType'));
            let budgetQuotationType = this.$store.getters['budget/getQuotationType'];
            if (checkLSQuotationType && checkLSQuotationType.description !== "") {
                budgetQuotationType = checkLSQuotationType;
            }
            if (budgetQuotationType) {
                this.breadcrumb[1].title = budgetQuotationType.description;
                this.titlePage = budgetQuotationType.description;
            }

            let checkLocalStorage = JSON.parse(localStorage.getItem('@datadrive:budgetStartedBy'));
            let budgetStartedBy = this.$store.getters['budget/getBudgetStartedBy'];
            if (checkLocalStorage.budgetName !== "") {
                budgetStartedBy = checkLocalStorage;
            }
            if (budgetStartedBy.budgetName == 'next-revision') {
                this.breadcrumb[1].title = this.$t('module-budget.main-budget.breadcrumb.next-revision')
                this.titlePage = this.$t('module-budget.main-budget.breadcrumb.next-revision')
            } else if (budgetStartedBy.budgetName == 'repair-graphic' || budgetStartedBy.budgetName == 'repair-service') {
                this.breadcrumb[1].title = this.$t('module-budget.main-budget.breadcrumb.repair')
                this.titlePage = this.$t('module-budget.main-budget.breadcrumb.repair')
            } else if (budgetStartedBy.budgetName == 'simple-revision') {
                this.breadcrumb[1].title = this.$t('module-budget.main-budget.breadcrumb.simple-review')
                this.titlePage = this.$t('module-budget.main-budget.breadcrumb.simple-review')
            } else if (budgetStartedBy.budgetName == 'history-budget') {
                this.breadcrumb[1].routerLinkName = 'budget-history';
                this.breadcrumb[1].title = this.$t('module-budget.main-budget.breadcrumb.history');
                if (this.breadcrumb.length > 2) {
                    this.breadcrumb[2].title = this.$t('module-budget.main-budget.breadcrumb.edit-budget');
                } else {
                    this.breadcrumb.push({
                        title: this.$t('module-budget.main-budget.breadcrumb.edit-budget')
                    })
                }
                this.titlePage = this.$t('module-budget.main-budget.breadcrumb.edit-budget');
            } else if (budgetStartedBy.budgetName == 'planning-module' || budgetStartedBy.budgetName == 'active-reception-planning-module') {
                let isARPlanning = budgetStartedBy.budgetName == 'active-reception-planning-module';
                let planningObj = JSON.parse(localStorage.getItem('@datadrive:planning-event'))
                this.breadcrumb[0].routerLinkName = 'planning';
                this.breadcrumb[0].title = this.$t('module-budget.main-budget.breadcrumb.planning');
                if (planningObj.isCreate) {
                    if (isARPlanning) {
                        this.breadcrumb[1].routerLinkName = 'active-reception-create-planning';
                    } else {
                        this.breadcrumb[1].routerLinkName = 'create-planning';
                    }
                } else {
                    if (isARPlanning) {
                        this.breadcrumb[1].routerLinkName = 'active-reception-edit-planning';
                        this.breadcrumb[1].params = {planningId: planningObj.eventRecord.planningId};
                    } else {
                        this.breadcrumb[1].routerLinkName = 'edit-planning';
                        this.breadcrumb[1].params = {planningId: planningObj.eventRecord.planningId};
                    }
                }
                this.breadcrumb[1].title = planningObj.isCreate ? this.$t('planning.breadcrumb-title-create') : this.$t('planning.breadcrumb-title-edit');
                if (this.breadcrumb.length > 2) {
                    this.breadcrumb[2].title = this.$t('module-budget.main-budget.breadcrumb.edit-budget');
                } else {
                    this.breadcrumb.push({
                        title: this.$t('module-budget.main-budget.breadcrumb.edit-budget')
                    });
                }
                this.titlePage = this.$t('module-budget.main-budget.breadcrumb.edit-budget');
            } else if (budgetStartedBy.budgetName == 'active-reception-module') {
                this.breadcrumb[0].routerLinkName = 'active-reception';
                this.breadcrumb[0].title = this.$t('check-in-viatura-title')
                this.breadcrumb[1].routerLinkName = 'active-reception-services';
                this.breadcrumb[1].title = this.$t('active-reception-services')
                this.breadcrumb.push({
                    title: this.$t('active-reception-fast-revision')
                });
                this.titlePage = this.$t('active-reception-fast-revision')
            }

            const checkRouteName = this.$route.name;
            if (checkRouteName == 'budget-summary-preview') {
                this.breadcrumb[1].title = this.$t('module-budget.main-budget.breadcrumb.history')
                this.titlePage = this.$t('module-budget.main-budget.breadcrumb.history')
            }

            if (!this.breadcrumb[1].title) {
                this.breadcrumb[1].title = this.$t('module-budget.main-budget.breadcrumb.next-revision');
            }
        },
        laborCost() {
            return this.$store.getters['auth/getState'].laborCost
        },
        checkPlate() {
            return this.$store.getters['vehicleIdentification/getState'].plateNumber;
        },
        computedCheckForPlanningModule() {
            let authModules = this.$store.getters['auth/getState'].modules;
            let findPlanning = authModules.filter(e => e.moduleId == 15);
            if (findPlanning[0]) {
                return !!(findPlanning[0].isActive && findPlanning[0].isVisible);
            } else {
                return false;
            }
        },
        computedCheckRoute() {
            return this.$route.name === 'budget-summary';
        },
        computedArrayOfPlanIds() {
            const getBS = this.$store.getters['budget/getBudgetSummary'];
            if (getBS.operations && getBS.operations && getBS.operations.values && getBS.operations.values.length > 0) {
                const idsArray = getBS.operations.values.map(op => op.workId);
                return idsArray.filter(element => !element.toString().includes("-998"));
            } else {
                return []
            }
        },
        computedCheckWebshop() {
            let authModules = this.$store.getters['auth/getState'].modules;
            let findWebshop = authModules.find(e => e.moduleId == 7);
            if (findWebshop) {
                return !!(findWebshop.isActive && findWebshop.isVisible);
            } else {
                return false;
            }
        },
        isSMActive() {
            let authModules = this.$store.getters['auth/getState'].modules;
            let sm = authModules.find(e => e.moduleId == this.$globals.MODULES.SUPPLIER_MANAGEMENT.ID);
            if (sm) {
                return sm.isActive && sm.isVisible;
            }
            return false;

        },
        isPPPActive() {
            let ppp = this.businessConditionData.find(o => o.businessConditionID == 14);
            return ppp ? ppp.isSelected : false;
        },
        isPartOrderActive() {
            let partOrder = this.businessConditionData.find(o => o.businessConditionID == 8);
            return partOrder ? partOrder.isSelected : false;
        },
    },
    watch: {
        computedChangedShoppingCart(newValue, oldValue) {
            const deletedItem = this.$store.getters['budget/getB2bCurrentShoppingCart'].lastDeletedItem;
            if (deletedItem !== null && deletedItem !== '' && deletedItem !== undefined) {
                const workIdToRemove = deletedItem.item.workId;
                this.deleteOperationClicked(workIdToRemove, true);
            }
        },
        computedBudgetSummary: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            immediate: true,
            deep: true
        },
        hasAnyIamSelected: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            immediate: true,
            deep: true
        },
        computedShowIamTotals: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            immediate: true,
            deep: true
        },
        modalFreePart: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            immediate: true,
            deep: true
        },
        parts: {
            handler: function (newValue) {
                this.firstRenderParts++;
                if (this.firstRenderParts >= 3) {
                    let frontendPayload = {
                        operations: this.computedBudgetSummary.operations.values,
                        parts: newValue
                    }
                    this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
                }
                this.sortedParts = this.sortedPartsFn(newValue);
                return newValue;
            },
            immediate: true,
            deep: true,
        },
        operations: {
            handler: function (newValue) {
                return newValue;
            },
            immediate: true,
            deep: true,
        },
        checkBudgetStartedBy: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            immediate: false,
            deep: true
        },
        "progressBar.visualMessage": {
            handler: function (newValue, oldValue) {
                if (oldValue) {
                    if (newValue != oldValue) {
                        this.progressBar.showMessage = false;
                        setTimeout(() => {
                            this.progressBar.showMessage = true;
                        }, 50)
                    }
                }
            },
            immediate: false,
            deep: true
        },
        dataOperationTotalsForTotalizerOE: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        amISupplier() {
            RequestManagerServicesIsEntitySupplier(
                this.$store.getters["auth/getState"].entityParent
            )
                .then((response) => {
                    const isEntitySupplier = response.data.result;
                    const getUserModules = this.$store.getters['auth/getState'].modules;
                    const module = getUserModules.find(m => m.moduleId == this.$globals.MODULES.REQUEST_MANAGER.ID);

                    this.isSupplier = !!(!isEntitySupplier && module && module.isActive && module.isVisible);
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    throw new Error(
                        this.$t("b2b.promo-engine.campaign-list.error"),
                        error
                    );
                });
        },
        async onRejectSaveToPlanning() {
            this.modalGoToPlanning.show = false;
            await this.clearShoppingCart(true);
            this.$router.push({name: 'planning'});
        },
        clickChangedStepHeader(step) {
            this.$store.commit('budget/setB2b', {currentStep: step});

            this.$router.push({name: 'budget_nextRevision'})
        },
        checkIAM() {
            this.isCheckedIAM = true
        },
        showModalRemovePart(part) {
            this.removePart = _.cloneDeep(part)
            this.modalAlertRemove.show = true;
        },
        showModalEditPart(part) {
            this.editPart = _.cloneDeep(part);
            if (this.editPart.costPrice == "undefined" || !this.editPart.costPrice) {
                this.editPart['costPrice'] = String(this.editPart.price);
            } else {
                this.editPart.costPrice = String(this.editPart.costPrice);
            }
            this.editPart.price = String(this.editPart.price);
            this.modalEditPart.show = true;
        },
        onCancelEditPart() {
            this.modalEditPart.show = false
            this.editPart = []
        },
        stopProgressBar() {
            this.progressBar.isLooping = false;
            this.progressBar.percentage = 100;
            setTimeout(() => {
                this.progressBar.show = false;
            }, 500)
        },
        async startProgressBar() {
            this.progressBar.show = true;
            this.progressBar.percentage = 20;
            this.progressBar.isLooping = true;

            await this.handleSetVisualMessages(0);
        },
        onSaveEditPart() {
            const edit = _.cloneDeep(this.editPart)
            _.filter(this.parts, function (o) {
                if (o[0].itemMpId == edit.itemMpId) {
                    o[0].name = edit.name
                    o[0].price = edit.price
                    o[0].costPrice = edit.costPrice
                    o[0].quantities = edit.quantities
                    o[0].reference = edit.reference
                }
            })

            let cloneBudgetSummaryParts = this.computedBudgetSummary.parts.values;
            let alterCloneBudgetSummaryParts = [];
            alterCloneBudgetSummaryParts = cloneBudgetSummaryParts.map(el => {
                if (el.itemMpId == edit.itemMpId) {
                    return {
                        ...el,
                        name: edit.name,
                        price: edit.price,
                        costPrice: edit.costPrice,
                        quantity: edit.quantities[0].quantity,
                        reference: edit.reference,
                    };
                }
                return el;
            });
            this.$store.commit('budget/setBudgetSummaryPartsValues', alterCloneBudgetSummaryParts);
            this.onCancelEditPart()
        },
        cancelRemovePart() {
            this.removePart = []
            this.modalAlertRemove.show = false;
        },
        editOpration(Operations) {
            this.editOperation = _.cloneDeep(this.operations.filter(el => el.workId == Operations)[0]);
            this.editOperation['durationComplete'] = this.editOperation.duration.hours + ':' + this.editOperation.duration.minutes;
            this.editOperation['observations'] = this.editOperation.names.length > 1 ? this.editOperation.names[1] : '';
            this.modalEditOperations.show = true;
        },
        onCancelEditOperations() {
            this.modalEditOperations.show = false;
            this.editOperation = []
        },
        onSaveEditOperations() {
            if (this.editOperation.names.length > 1) {
                this.editOperation.names[1] = this.editOperation.observations;
            } else {
                this.editOperation.names = [this.editOperation.names[0], this.editOperation.observations];
            }
            let edit = _.cloneDeep(this.editOperation)

            this.operations.forEach(el => {
                if (el.workId == this.editOperation.workId) {
                    el.reference = this.editOperation.reference;
                    el.names = this.editOperation.names;
                    el.duration = {
                        hours: this.editOperation.durationComplete.split(':')[0],
                        minutes: this.editOperation.durationComplete.split(':')[1],
                    };
                    el.description = this.editOperation.description;
                }
            });

            let cloneBudgetSummaryOperations = this.computedBudgetSummary.operations.values;
            let alterCloneBudgetSummaryOperations = []
            cloneBudgetSummaryOperations.map(el => {
                if (el.itemMpId == edit.itemMpId) {
                    el.names = edit.names
                    el.reference = edit.reference
                    el.duration = edit.duration
                    el.description = edit.description
                }
                alterCloneBudgetSummaryOperations.push(el);
            })

            this.$store.commit('budget/setBudgetSummaryOperationsValues', alterCloneBudgetSummaryOperations);

            this.onCancelEditOperations()
        },
        showModalRemoveOperations(Operations, entityPackageServiceId) {
            this.removeOperations = _.cloneDeep(Operations);
            this.removeOperationByEntityServicePackageId = _.cloneDeep(entityPackageServiceId);
            this.modalAlertRemoveOperations.show = true;
        },
        cancelRemoveOperations() {
            this.removeOperations = [];
            this.removeOperationByEntityServicePackageId = '';
            this.modalAlertRemoveOperations.show = false;
        },
        async deletePartsClicked() {
            let isFree = false;
            const part = this.removePart;
            if (String(part.workId).includes('-998') || String(part.itemMpId).includes('-998')) {
                await this.onClickToDeletePart();
                return;
            }

            delete this.parts[part.itemMpId];
            await this.$nextTick();

            if (String(part.itemMpId).includes('-111')) {
                isFree = true;
                let cloneParts = _.cloneDeep(this.parts);
                delete cloneParts[part.itemMpId];
                // for (let key in cloneParts) {
                //   console.log('cloneParts', cloneParts[key])
                //   let filter = await cloneParts[key].filter(item => String(item.itemMpId) == String(part.itemMpId));
                //   console.log("filter", filter)
                //   // if (cloneParts[key].length === 0) {
                //   //   delete cloneParts[key];
                //   // }
                // }

                // var filtered = Object.filter(cloneParts, ([name, arr]) => String(name.itemMpId) == String(part.itemMpId));
                // var filtered = _.filter(cloneParts,function(o) {
                //   if(o[0].itemMpId != part.itemMpId){
                //     return o[0];
                //   }
                // })
                // console.log('filtered', filtered);
                this.parts = cloneParts;

                let frontendPayload = {
                    operations: this.operations,
                    parts: this.parts
                }

                this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
                localStorage.setItem('@copyShoppingCart', JSON.stringify(frontendPayload));

                this.$store.commit('budget/setMaintenanceShoppingCartPartsOnDeleteFreePart', this.parts);

                await this.$nextTick();

                this.$store.commit('loadings/setStateLoadingTemplate', true);
                setTimeout(() => {
                    this.updateTotalOeOnlyValue();
                }, 1000);
            }

            let cloneBudgetSummaryParts = this.computedBudgetSummary.parts.values;
            const indexBsPart = cloneBudgetSummaryParts.findIndex(el => String(el.itemMpId) == String(part.itemMpId));
            if (indexBsPart !== -1) {
                const filterPart = cloneBudgetSummaryParts.filter(el => el.itemMpId !== cloneBudgetSummaryParts[indexBsPart].itemMpId);
                this.$store.commit('budget/setBudgetSummaryPartsValues', filterPart);
            }

            if (this.computedBudgetSummary.parts.values && this.computedBudgetSummary.parts.values.length === 0) {
                const partsTotals = {
                    globalDiscount: 0,
                    totalWithoutDiscount: 0,
                    totalWithDiscount: 0,
                    totalOeOnlyWithDiscount: 0
                };
                this.$store.commit('budget/setPartTotalsToBudgetSummary', partsTotals);
                this.$store.commit('budget/setShoppingCartTotals', {isOp: false, totals: partsTotals});
            }

            // Clear last deleted item
            this.$store.commit('budget/setLastDeletedShoppingCartItem', '');
            await this.$nextTick();
            this.cancelRemovePart();

            if (isFree) {
                this.isReady = false;
                setTimeout(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                    this.isReady = true;
                }, 1000);
            }

            if (part.workId) {
                this.deleteOperationClicked(part.workId, true, null);
            }
        },
        async onClickToDeletePart() {
            let cloneParts = this.parts;
            const partClickedToDelete = _.cloneDeep(this.removePart);
            const clonePartClickedItemMpId = this.removePart?.itemMpId ? _.cloneDeep(this.removePart.itemMpId) : null;
            const clonePartClickedWorkId = this.removePart?.workId ? _.cloneDeep(this.removePart.workId) : null;

            // Verifico se é um pacote de serviço
            if (String(clonePartClickedWorkId).includes('-998') || String(clonePartClickedItemMpId).includes('-998')) {
                let partId = partClickedToDelete.partId;
                let findOperationAssociated = null;
                let entityPackageServiceId = partClickedToDelete.entityPackageServiceId;
                let findAssociatedPartsOnly = null;
                const findOperationAssociatedByEntityPacks = this.operations.find(operation => operation.entityPackageServiceId == entityPackageServiceId);
                findOperationAssociated = this.operations.find(operation => String(operation.workId) == String(clonePartClickedWorkId));
                if (!findOperationAssociated) {
                    findOperationAssociated = this.operations.find(operation => String(operation.itemMpId) == String(clonePartClickedItemMpId));
                    if (findOperationAssociated) {
                        this.$store.commit('budget/setLastDeletedShoppingCartItem', '');
                        await this.$nextTick();
                        this.cancelRemovePart();
                        this.deleteOperationClicked(clonePartClickedWorkId, true, entityPackageServiceId);
                    } else if (findOperationAssociatedByEntityPacks) {
                        this.$store.commit('budget/setLastDeletedShoppingCartItem', '');
                        await this.$nextTick();
                        this.cancelRemovePart();
                        this.deleteOperationClicked(clonePartClickedWorkId, true, entityPackageServiceId);
                    } else {
                        // Tem peça irmã mas não tem operação pai
                        async function removeAssociated() {
                            for (let key in cloneParts) {
                                cloneParts[key] = await cloneParts[key].filter(item => item.entityPackageServiceId !== entityPackageServiceId);
                                if (cloneParts[key].length === 0) {
                                    delete cloneParts[key];
                                }
                            }
                        }

                        await removeAssociated();
                        this.parts = cloneParts;

                        let frontendPayload = {
                            operations: this.operations,
                            parts: this.parts
                        }

                        this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
                        localStorage.setItem('@copyShoppingCart', JSON.stringify(frontendPayload));
                        this.$store.commit('budget/setMaintenanceShoppingCartPartsOnDeleteFreePart', this.parts);

                        // Essa loucura de ter carrinho, e budget, se faz necessário remover também do budgetSummary
                        const filterPart = this.computedBudgetSummary.parts.values.filter(el => el.entityPackageServiceId !== entityPackageServiceId);
                        this.$store.commit('budget/setBudgetSummaryPartsValues', filterPart);

                        // Atualiza as stores do Summary e o somatório dos totalizers se não houver peças
                        if (this.computedBudgetSummary.parts.values && this.computedBudgetSummary.parts.values.length === 0) {
                            const partsTotals = {
                                globalDiscount: 0,
                                totalWithoutDiscount: 0,
                                totalWithDiscount: 0,
                                totalOeOnlyWithDiscount: 0
                            };
                            this.$store.commit('budget/setPartTotalsToBudgetSummary', partsTotals);
                            this.$store.commit('budget/setShoppingCartTotals', {isOp: false, totals: partsTotals});
                        }

                        this.$store.commit('budget/setLastDeletedShoppingCartItem', '');
                        await this.$nextTick();
                        this.cancelRemovePart();

                        await this.$nextTick();

                        this.isReady = false;
                        setTimeout(() => {
                            this.isReady = true;
                        }, 500);
                    }
                } else {
                    this.$store.commit('budget/setLastDeletedShoppingCartItem', '');
                    await this.$nextTick();
                    this.cancelRemovePart();
                    this.deleteOperationClicked(clonePartClickedWorkId, true, entityPackageServiceId);
                }
            }
        },
        async deleteOperationClicked(iddd, isDeleteOnCart, entityPackageServiceId) {
            let workId = ''
            if (isDeleteOnCart && isDeleteOnCart === true) {
                workId = iddd;
            } else {
                workId = this.removeOperations
            }
            let newEntityServicePackageId = '';
            if (entityPackageServiceId) {
                newEntityServicePackageId = entityPackageServiceId;
            } else {
                newEntityServicePackageId = this.removeOperationByEntityServicePackageId;
            }

            let findStateOfIAM = this.$store.getters['budget/getBudgetSummary'].stateForTotalizersCalcsIAM;
            if (findStateOfIAM !== null && findStateOfIAM !== undefined && findStateOfIAM.length > 0) {
                let iam = findStateOfIAM.filter(e => e.workId != workId)
                this.$store.commit('budget/setBudgetPayloadForTotalizersAllCalcsIam', iam);
            }

            let findStateOfOE = this.$store.getters['budget/getBudgetSummary'].stateForTotalizersCalcsOE;
            if (findStateOfOE !== null && findStateOfOE !== undefined && findStateOfOE.length > 0) {
                let op = findStateOfOE.filter(e => e.workId != workId);
                this.$store.commit('budget/setBudgetPayloadForTotalizersAllCalcsOE', op);
            }

            let payload = {
                item: this.computedCurrentShoppingCart.operations.maintenance.find(operation => workId == operation.workId),
                type: 'maintenance'
            };
            let operationFilteritem = this.operations.filter(el => el.workId == workId);

            // if the operation is not maintenance, payload.item will be undefined
            if (!payload.item) {
                payload.type = 'repair';
                payload.item = this.computedCurrentShoppingCart.operations.repair.find(operation => workId == operation.workId);
            }

            // remove locally
            this.$delete(
                this.operations,
                this.operations.findIndex(operation => workId == operation.workId)
            );
            // ---

            // remove locally parts
            let itemMpIdToRemoveFromPart;
            if (!operationFilteritem[0]) {
                const findByEntityPack = await this.operations.find(op => op.entityPackageServiceId == entityPackageServiceId);
                itemMpIdToRemoveFromPart = findByEntityPack.itemMpId;
            } else {
                itemMpIdToRemoveFromPart = operationFilteritem[0].itemMpId;
            }
            let cloneParts = _.cloneDeep(this.parts);

            Object.filter = (obj, predicate) => Object.fromEntries(Object.entries(obj).filter(predicate));

            var filtered = await Object.filter(cloneParts, ([name, arr]) => arr[0].itemMpId !== itemMpIdToRemoveFromPart);
            this.parts = filtered;

            this.parts = await Object.filter(filtered, ([name, arr]) => arr[0].workId != workId);

            let cloneBudgetSummaryParts = _.cloneDeep(this.computedBudgetSummary.parts.values);
            const indexBsPart = await cloneBudgetSummaryParts.findIndex(el => el.itemMpId == itemMpIdToRemoveFromPart);
            if (indexBsPart !== -1) {
                const filterPart = await cloneBudgetSummaryParts.filter(el => String(el.itemMpId) !== String(cloneBudgetSummaryParts[indexBsPart].itemMpId));
                this.$store.commit('budget/setBudgetSummaryPartsValues', filterPart);
            }

            let cloneBudgetSummaryOperations = this.computedBudgetSummary.operations.values;
            const indexBs = await cloneBudgetSummaryOperations.findIndex(el => String(el.workId) == String(workId));
            if (indexBs !== -1) {
                const filter = await cloneBudgetSummaryOperations.filter(el => String(el.workId) !== String(cloneBudgetSummaryOperations[indexBs].workId));
                this.$store.commit('budget/setBudgetSummaryOperationsValues', filter);
            }

            let cloneBudgetSummaryPartsNew = _.cloneDeep(this.computedBudgetSummary.parts.values);
            const indexBsPartNew = await cloneBudgetSummaryPartsNew.findIndex(el => String(el.workId) == String(workId));
            if (indexBsPartNew !== -1) {
                const filterPartNew = await cloneBudgetSummaryPartsNew.filter(el => String(el.workId) !== String(cloneBudgetSummaryPartsNew[indexBsPartNew].workId));
                this.$store.commit('budget/setBudgetSummaryPartsValues', filterPartNew);
            }

            if (String(workId).includes('-998')) {
                let cloneBudgetSummaryParts = this.computedBudgetSummary.parts.values;
                if (newEntityServicePackageId !== '') {
                    const filterPart = await cloneBudgetSummaryParts.filter(el => String(el.entityPackageServiceId) !== String(entityPackageServiceId));
                    this.$store.commit('budget/setBudgetSummaryPartsValues', filterPart);
                    this.parts = await Object.filter(filtered, ([name, arr]) => String(arr[0].entityPackageServiceId) !== String(newEntityServicePackageId));
                }
            }

            // -- init forced resolution of an operations calculus reactivity problem!
            let newCloneParts = _.cloneDeep(this.computedBudgetSummary.parts.values);
            let newPartsValuesArr = [];
            let listOfPartsKeys = Object.keys(this.parts);
            let listOfPartsKeysArray = [listOfPartsKeys];

            await newCloneParts.forEach(part => {
                listOfPartsKeysArray.forEach(partSecondNode => {
                    partSecondNode.forEach(partThirdNode => {
                        if (part.itemMpId == partThirdNode) {
                            newPartsValuesArr.push(part);
                        }
                    })
                })

                let id = String(part.itemMpId)
                if (id.includes('-111')) {
                    const findAlrearyPartAdd = newPartsValuesArr.find(elPart => elPart.itemMpId == id);
                    if (!findAlrearyPartAdd) {
                        newPartsValuesArr.push(part);
                    }
                }
            })

            const cloneNew = _.cloneDeep(newPartsValuesArr);
            const storePayload = {
                data: cloneNew,
                workIdToDelete: workId,
                itemMpIdToDelete: itemMpIdToRemoveFromPart
            }

            await this.$nextTick();

            this.$store.commit('budget/setBudgetSummaryPartsValuesWhenDelete', storePayload);
            // -- end

            if (this.computedBudgetSummary.parts.values && this.computedBudgetSummary.parts.values.length === 0) {
                const partsTotals = {
                    globalDiscount: 0,
                    totalWithoutDiscount: 0,
                    totalWithDiscount: 0,
                    totalOeOnlyWithDiscount: 0
                };
                this.$store.commit('budget/setPartTotalsToBudgetSummary', partsTotals);
                this.$store.commit('budget/setShoppingCartTotals', {isOp: false, totals: partsTotals});
            }

            // Clear last deleted item
            this.$store.commit('budget/setLastDeletedShoppingCartItem', '');

            // remove from the store
            // if the user deletes an operation from the cart, then, when this method is called, the operation was already removed from the store
            if (payload.item) this.$store.commit('budget/setB2bRemoveOrAddShoppingCartItem', payload);

            let frontendPayload = {
                operations: this.operations,
                parts: this.parts
            }
            this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
            localStorage.setItem('@copyShoppingCart', JSON.stringify(frontendPayload));
            this.$store.commit('budget/setUpdateShoppingCartParts', frontendPayload.parts);

            await this.$nextTick();
            this.checkEmptyCart();

            const isOnDelete = true;
            const idToDelete = workId;
            let quotationOrder = null;
            if (this.$route.name == "budget-summary-edit") {
                quotationOrder = 2;
            }

            let updateParts = cloneNew.filter(p => String(p.workId) !== String(workId));

            updateParts = updateParts.filter(p => String(p.itemMpId) !== String(itemMpIdToRemoveFromPart));
            this.$store.commit('budget/setBudgetSummaryPartsValues', updateParts);

            this.getBudgetData(isOnDelete, null, null, idToDelete, quotationOrder, null, itemMpIdToRemoveFromPart);

            this.modalAlertRemoveOperations.show = false;

        },
        getCartOpsLength() {
            let cart = this.$store.getters['budget/getShoppingCartCopy'];
            return cart.operations.length;
        },
        async checkEmptyCart() {
            if (this.getCartOpsLength() === 0) {
                await this.clearShoppingCart(false, true);
            }
        },
        onClickedOnNoOption() {
            this.modalAskForSave.show = false;
            this.clearShoppingCart();
        },
        async clearShoppingCart(isEdit, byCheckEmptyCart) {
            this.showTotalizers = false;
            this.$store.commit('loadings/setStateLoadingTemplate', true);
            let processNummber = this.$store.getters['vehicleIdentification/getState'].processNumber;
            this.$store.commit('budget/setCurrentProcessNumberByCar', processNummber);
            this.$store.commit('budget/setB2bClearShoppingCart');
            this.$store.commit('budget/setB2bClearShoppingCartToStep2');
            localStorage.removeItem('budgetB2b');

            await this.$helpers.handleRenewProcessNumber(this.forceResolveVehicle);

            if (this.$route.name !== "dashboard" && !isEdit && !byCheckEmptyCart) {
                this.$router.push({name: 'dashboard'});
            }
            await this.$nextTick();
            const shoppingCartCopy = {
                operations: [],
                parts: [],
            }
            const payloadBudgetStartedBy = {
                budgetId: null,
                budgetName: ''
            }
            const shoppingCartTotals = {
                operations: {totals: {}},
                parts: {totals: {}}
            }
            this.$store.commit('budget/setBudgetStartedBy', payloadBudgetStartedBy);
            this.$store.commit('budget/setShoppingCartCopy', shoppingCartCopy);
            this.$store.commit('budget/setShoppingCartTotalsClear', shoppingCartTotals);
            this.$store.commit('activeReception/setActiveReceptionServicesAssociatedQuotationId', null);
            this.$store.commit('budget/setB2bCurrentStep', 1);
            localStorage.removeItem('@copyShoppingCart');
            localStorage.removeItem('@shoppingCartTotals');
            localStorage.removeItem('budgetB2b');
            this.$store.commit('budget/setClearBudgetSummary', {});
            this.$store.commit('budget/setB2bClearShoppingCart');
            this.$store.commit('loadings/setStateLoadingTemplate', false);
            await this.$nextTick();
            if (byCheckEmptyCart) {
                if (this.$route.name !== "dashboard") {
                    this.$router.push({name: 'dashboard', params: {clearCartAgain: true}});
                }
            }
        },
        toggleAllIamParts(newValue) {
            this.hasAnyIamSelected = newValue;

            this.$refs.partsRow.forEach(part => {
                let wasIamAlready = part.selectedPart.isIam;
                if ((!this.isIamWithoutSM && part.computedHasIamParts) ||
                    (this.isIamWithoutSM && !this.checkIfIsEcolub(part.selectedPart) && !this.checkIfIsPackageService(part.selectedPart) && !this.checkIfIsFreePart(part.selectedPart))) {
                    part.selectedPart.isIam = newValue;
                }
            });

            this.$store.commit('budget/setMaintenanceShoppingCartParts', this.parts);

            if (this.$route.name === 'budget-summary-edit') {
                this.switchCounter++;
            }
        },
        partIamSwitchChanged(newValue) {
            this.hasAnyIamSelected = newValue || this.$refs.partsRow.some(row => row.isIam); // the current part only updates after this is run, so we just check its newValue

            let filterOe = this.$refs.partsRow.filter(row => (row.isOe == false));
            this.hasAnyIamSelected = filterOe.length !== 0;

            if (newValue) {
                this.isAllIam = this.$refs.partsRow.every(row => !row.computedHasIamParts || row.selectedPart.isIam);
            } else {
                this.isAllIam = false;
            }

            this.$store.commit('budget/setMaintenanceShoppingCartParts', this.parts);
            if (this.$route.name === 'budget-summary-edit') {
                this.switchCounter++;
            }
        },
        async handleSetVisualMessages(count) {
            this.progressBar.visualMessage = this.progressBar.messages[count++];
            if (this.progressBar.percentage < 80) {
                this.progressBar.percentage += 20;
            }
            if (count >= this.progressBar.messages.length) {
                count = 0;
            }
            if (this.progressBar.isLooping) {
                setTimeout(() => {
                    this.handleSetVisualMessages(count);
                }, 2000);
            }
        },
        async getBudgetData(isOnDelete, callback, carInfo, idToDelete, quotationOrder, partId, itemMpIdToRemoveFromPart) {
            this.startProgressBar();

            if (['budget-summary-preview', 'budget-summary-edit'].indexOf(this.$route.name) >= 0 && quotationOrder == undefined && !this.$route.params?.preventLoadEdit) {
                // console.log('### 1')
                await QuotationServicesGetQuotation(this.$route.params.id, null, null, idToDelete, partId)
                    .then(response => {
                        if (response.result.observations) {
                            this.observationsQuotation = response.result.observations;
                        }
                        this.hasPlanningId = response.result?.planningId;
                        if (response.result.hasInvoice) {
                            this.hasInvoice = true;
                            if (['budget-summary-edit'].indexOf(this.$route.name) >= 0) {
                                this.clearShoppingCart()
                            }
                        }

                        var filterOutServicePackages = response.operations.filter(o => !o.entityPackageServiceId);
                        // if there's only one operation and it's called 'diagnóstico' duplicate the hourValue to all servicePackages
                        if (filterOutServicePackages.length == 1 && filterOutServicePackages[0].names.filter(name => name.toLowerCase().includes('diagnóstico')).length > 0) {
                            response.operations.forEach(o => o.hourValue = filterOutServicePackages[0].hourValue);
                        }
                        if (response.result.km || this.$route.params.kms) {
                            this.$store.commit('budget/setB2bKM', {
                                fields: {
                                    Kilometers: response.result.km ? response.result.km : this.$route.params.kms
                                }
                            });
                        }

                        this.isPreviewOrEdit = true;

                        carInfo = {
                            dataSourceId: String(response.result.quotationDataSourceId),
                            processNumber: this.ProcessNumber,
                            make: response.result.make,
                            model: response.result.model,
                            bodyGroup: response.result.bodyGroup,
                            fuelType: response.result.fuelType,
                            version: response.result.version,
                            kType: response.result.kType,
                            manualPlate: response.result.manualPlate,
                            plate: response.result.plate ? response.result.plate : '',
                        }

                        this.vehicleInfo = `${response.result.make} ${response.result.model}`
                        if (response.result?.version) {
                            this.vehicleInfo = `${this.vehicleInfo} ${response.result.version}`
                        }
                        this.operations = response.operations,
                            this.parts = response.parts

                        let frontendPayload = {
                            operations: response.operations,
                            parts: response.parts
                        }
                        this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
                        localStorage.setItem('@copyShoppingCart', JSON.stringify(frontendPayload));

                        this.globalOperationsDiscount = response.operationsGlobalDiscount;
                        this.globalPartsDiscount = response.partsGlobalDiscount;

                        if (!this.isPreview) {
                            let maintenance = this.operations;
                            maintenance = maintenance.map(item =>
                                Object.assign(item, {
                                    workPosDescription: item.names[0],
                                    singleWorkTime: +item.duration.hours,
                                    totalWorkTime: +item.duration.minutes
                                })
                            );

                            /**
                             * START
                             * Way to solve a problem in the short term.
                             * The BudgetSummary computed was looping from too many calls.
                             * That was the way to fix it quickly. We should refactor this code obviously
                             */
                            new Promise((resolve, reject) => {
                                try {
                                    resolve(this.$store.commit('budget/setMaintenanceShoppingCartOperations', maintenance));
                                } catch (e) {
                                    reject("error on primise get budget promisse", e);
                                }
                            }).then(() => {
                                setTimeout(() => {
                                    this.$store.commit('budget/setMaintenanceShoppingCartParts', this.parts);
                                }, 500);
                            }).then(() => {
                                setTimeout(() => {
                                    this.$store.commit('budget/setB2bShoppingCartNumberOfParts');
                                }, 500);
                            })
                            // END

                            let payload = {
                                maintenance: maintenance,
                                parts: this.parts,
                                quotationId: this.$route.params.id,
                                internalId: this.$route.params.token
                            };

                            this.$store.commit('budget/setLastBudgetSelectedToCompare', payload);
                        }

                        if (this.operations) {
                            this.searchForInactiveLaborValue();
                        }

                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        console.error('Error in BudgetSummary getData1 ', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);

                        if (isOnDelete) {
                            this.isReady = false;
                            setTimeout(() => {
                                this.isReady = true;
                            }, 5);
                        }

                        this.stopProgressBar();

                        this.showDiagnosticTotalizer = true;

                        if (callback) callback(carInfo);
                    });
            } else if (this.computedLastBudget !== null && this.computedLastBudget !== undefined || this.$route.params?.preventLoadEdit) {
                if (this.computedLastBudget.quotationId !== null && this.computedLastBudget.quotationId !== undefined) {
                    // console.log('### 2')
                    /*
                      Pay attention to this method!

                      This method, done on 12/15/2020, was the quickest solution to solve a problem.

                      The problem: the problem was that in case of editing the budget and if the user wanted to store a part or operation
                      to this existing budget, if that budget had any IAM switch to true, it should come to true when setting up the budget again.
                      Detail that with each edition, it generates a new budget, therefore the 'problem'.

                      For this, two states were used in which we stored the old budget and the current budget, a comparison occurs between the two,
                      filtering out the IAM pieces that were true, and making the pieces go from the new budget to true as well.
                      This after receiving the specific payload.
                  */

                    const ids = getOperationIds.call(this);
                    const qualColIds = getQualColId.call(this);

                    let quotationId = this.computedLastBudget.quotationId;
                    let internalId = this.computedLastBudget.internalId;

                    // TODO: this should be an action dispatched to the store, and that would even remove the need to do the getOperationIds here
                    await QuotationServicesGetData(qualColIds, internalId, quotationId, idToDelete, partId)
                        .then(response => {
                            this.operations = response.operations;
                            this.parts = response.parts;

                            /** Search for Free Operation to add in table
                             * Because when you hit the endpoint that the parts and operations are looking for,
                             * the id of the free operation does not exist in the DB,
                             * because it is generated randomly on the frontend side
                             * (something to be corrected later) so you have to find that free piece and add it to the hand.
                             */
                            let budgetOp = this.computedBudgetSummary.operations.values.map(el => el.itemMpId);
                            budgetOp.forEach((element, index) => {
                                if (typeof element === String) {
                                    if (element.includes('-111')) {
                                        let freeOp = this.computedBudgetSummary.operations.values.filter(
                                            el => el.itemMpId == budgetOp[index]
                                        );
                                        this.operations.push(freeOp[0]);
                                    }
                                }
                            })
                            // --------- end

                            // Search for Free Part
                            let flat = _.flatMap(this.computedCurrentShoppingCart.parts);
                            let budgetParts = flat.map(el => el);
                            budgetParts.forEach((element, index) => {
                                if (String(element.itemMpId).includes('-111')) {
                                    let freePart = flat.filter(el => el.itemMpId == budgetParts[index].itemMpId);
                                    let newArrPart = []
                                    newArrPart[freePart[0].itemMpId] = freePart;
                                    this.parts = {
                                        ...this.parts,
                                        ...newArrPart
                                    };
                                }

                                if (element.iamParts) {
                                    element.iamParts.forEach((item, index) => {
                                        if (item.freeIamPart) {
                                            let itemMpId = item.itemMpId;
                                            let indexIamPart = this.parts[itemMpId].findIndex(e => e.isSelected === true);
                                            if (indexIamPart !== -1) {
                                                this.parts[itemMpId][indexIamPart].iamParts.push(item);
                                            }
                                        }
                                    })
                                }
                            });
                            // --------- end

                            let maintenance = this.operations;
                            maintenance = maintenance.map(item =>
                                Object.assign(item, {
                                    workPosDescription: item.names[0],
                                    singleWorkTime: +item.duration.hours,
                                    totalWorkTime: +item.duration.minutes
                                })
                            );

                            let payload = {
                                maintenance: maintenance,
                                parts: this.parts,
                                quotationId: quotationId,
                                internalId: internalId
                            };

                            this.$store.commit('budget/setLastBudgetSelectedToCompareId', {});

                            Object.filter = function (obj, predicate) {
                                let result = {},
                                    key;
                                for (key in obj) {
                                    if (obj.hasOwnProperty(key) && !predicate(obj[key])) {
                                        result[key] = obj[key];
                                    }
                                }
                                return result;
                            };

                            let searchForIam = Object.filter(this.computedLastBudget.parts, part => part.isIam === true);

                            for (let item in payload.parts) {
                                for (let key in searchForIam) {
                                    for (let i in payload.parts[item]) {
                                        for (let index in searchForIam[key]) {
                                            if (payload.parts[item][i].itemMpId == searchForIam[key][index].itemMpId) {
                                                if (searchForIam[key][index].isIam == true) {
                                                    payload.parts[item][i].isIam = searchForIam[key][index].isIam;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            this.operations = payload.maintenance;
                            this.parts = payload.parts;

                            this.$store.commit('budget/setNewBudgetToCompare', payload);
                            this.$store.commit('budget/setLastBudgetSelectedToCompare', payload);

                            if (response) {
                                this.resolveFreeOperationsAndParts(false, idToDelete, response, itemMpIdToRemoveFromPart)
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            this.modalRequest.show = true;
                            console.error('Error in BudgetSummary getData2 ', error);
                        })
                        .finally(() => {
                            if (isOnDelete) {
                                this.isReady = false;
                                setTimeout(() => {
                                    this.isReady = true;
                                }, 5);
                            }
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            if (this.$route.name !== "budget-summary-edit") {
                                this.$router.replace({name: 'budget-summary-edit', params: {id: quotationId}});
                            }
                            this.showDiagnosticTotalizer = true;

                            this.stopProgressBar();
                        });

                    /**
                     * @description gets the operation IDs that are stored in the shopping cart
                     */
                    function getOperationIds() {
                        const maintenance = this.computedCurrentShoppingCart.operations.maintenance;
                        const repair = this.computedCurrentShoppingCart.operations.repair;
                        return [...maintenance, ...repair].map(item => item.workId);
                    }

                    function getQualColId() {
                        const maintenance = this.computedCurrentShoppingCart.operations.maintenance;
                        const repair = this.computedCurrentShoppingCart.operations.repair;
                        const workIdWithQualColIdArray = [];
                        repair.forEach(item => {
                            if (item.qualColId !== '') {
                                let newObj = {
                                    workId: item.workId,
                                    qualColId: item.qualColId
                                }
                                workIdWithQualColIdArray.push(newObj)
                            } else {
                                let newObj2 = {
                                    workId: item.workId,
                                }
                                workIdWithQualColIdArray.push(newObj2)
                            }
                        });
                        maintenance.forEach(item => {
                            let newObj3 = {
                                workId: item.workId,
                            }
                            workIdWithQualColIdArray.push(newObj3)
                        })
                        return workIdWithQualColIdArray;
                    }
                }
            } else {
                // console.log('### 3')
                const ids = getOperationIds.call(this);
                const qualColIds = getQualColId.call(this);
                const removeFreeAndPackagesIds = qualColIds.filter(element => !String(element.workId).includes('-998') && !String(element.workId).includes('-999') && !String(element.workId).includes('-111'))
                // TODO: this should be an action dispatched to the store, and that would even remove the need to do the getOperationIds here
                await QuotationServicesGetData(removeFreeAndPackagesIds, null, null, idToDelete, partId)
                    .then(response => {
                        this.operations = response.operations;
                        this.parts = response.parts;

                        for (let key in this.parts) {
                            this.parts[key].map(el => {
                                if (!el.reference) {
                                    el.reference = ''
                                }
                            })
                        }

                        if (response) {
                            this.resolveFreeOperationsAndParts(false, idToDelete, response, itemMpIdToRemoveFromPart);
                        }

                    })
                    .catch(error => {
                        if (error.message == "REDIRECT_BACK") {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            setTimeout(() => {
                                return this.$router.push({name: "budget"});
                            }, 500)
                        }

                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        this.modalRequest.show = true;
                        console.error('Error in BudgetSummary getData2 ', error);
                    })
                    .finally(() => {
                        if (isOnDelete) {
                            this.isReady = false;
                            setTimeout(() => {
                                this.isReady = true;
                            }, 5);
                        }

                        this.stopProgressBar();

                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                        this.showDiagnosticTotalizer = true;
                    });

                /**
                 * @description gets the operation IDs that are stored in the shopping cart
                 */
                function getOperationIds() {
                    const maintenance = this.computedCurrentShoppingCart.operations.maintenance;
                    const repair = this.computedCurrentShoppingCart.operations.repair;
                    return [...maintenance, ...repair].map(item => item.workId);
                }

                function getQualColId() {
                    const maintenance = this.computedCurrentShoppingCart.operations.maintenance;
                    const repair = this.computedCurrentShoppingCart.operations.repair;
                    const workIdWithQualColIdArray = [];
                    repair.forEach(item => {
                        if (item.qualColId !== '') {
                            let newObj = {
                                workId: item.workId,
                                qualColId: item.qualColId
                            }
                            workIdWithQualColIdArray.push(newObj)
                        } else {
                            let newObj2 = {
                                workId: item.workId,
                            }
                            workIdWithQualColIdArray.push(newObj2)
                        }
                    });
                    maintenance.forEach(item => {
                        let newObj3 = {
                            workId: item.workId,
                        }
                        workIdWithQualColIdArray.push(newObj3)
                    })
                    return workIdWithQualColIdArray;
                }
            }
        },
        continueBudget() {
            this.modalCheckEmptyPart.show = false;
            this.modal.show = true;
            this.modalCheckEmptyPart.count = 1;
        },
        /**
         * @param modalType check the dataTypes on data.modal.types
         */
        showModal(modalType) {
            this.modal.type = modalType;

            let parts = this.computedBudgetSummary.parts.values;
            parts = parts.map(el => el.price);
            let filterEmpty = parts.some(elem => elem <= 0)
            if (filterEmpty && this.modalCheckEmptyPart.count === 0) {
                this.modalCheckEmptyPart.show = true;
            } else {
                this.modal.show = true;
            }

        },
        /**
         * @description resets all the prices that were changed by the user to their default values
         *               the price component has a ref="pricePart" to let us access its instance
         *               and therefore call it's resetPrice() method that will reset the price himself
         */
        resetPricesClicked() {
            this.$refs.partsRow.forEach(part => {
                part.resetPrice();
            });
        },
        sendEmailClicked() {
            this.showModal(this.modal.types.SEND_EMAIL);
        },
        printClicked() {
            this.showModal(this.modal.types.PRINT);
        },
        sendWebShopClicked() {

            this.showModal(this.modal.types.WEBSHOP)
        },
        modalActionClicked(payload) {

            this.modal.show = false;
            this.showModalOrder.show = false;
            this.modal.infoType = this.modal.type;

            this.$store.commit('loadings/setStateLoadingTemplate', true);

            let printDocument = false;
            let sendEmail = false;

            if (this.$route.name === 'budget-summary-preview') {
                let backendPayload = this.buildBackendPayload(payload);
                let quotationId = this.$route.params.id;
                return this.printInPreviewMode(quotationId, backendPayload);
            }

            if (this.modal.type == 'reject') {
                this.rejectedQuotation = true;
            }

            if (this.modal.type == 'print' || this.modal.type == 'send-email') {
                let backendPayload = this.buildBackendPayload(payload);
                let quotationId = null;
                if (this.$route.params.id || this.$route.name === 'budget-summary-preview') {
                    quotationId = this.$route.params.id;
                }
                ;
                if (backendPayload?.observations || backendPayload.observations == "") {
                    delete backendPayload.observations;
                }
                if (this.$route.params.quotationId && quotationId == null) {
                    quotationId = this.$route.params.quotationId;
                }
                return this.printInPreviewMode(quotationId, backendPayload);
            }

            this.sendBudgetDataToBackend(payload)
                .then(response => {
                    this.newQuotationId = response?.data?.result?.id;
                    if (this.modal.infoType === this.modal.types.SEND_EMAIL) {
                        sendEmail = true;
                        this.sendEmail = true;
                        return QuotationServicesSendEmailAndPDF(response.data.result.id, payload.quotationFormEmail, true);
                    } else if (this.modal.infoType === this.modal.types.PRINT) {
                        printDocument = true;
                        return QuotationServicesSendEmailAndPDF(response.data.result.id, payload.quotationFormEmail, false);
                    } else if (this.modal.infoType === this.modal.types.WEBSHOP) {
                        const quotationId = this.$route.params.id;

                        QuotationServicesGetWebShop(quotationId)
                            .then(response => {
                                window.open(response.data.result, '_blank');
                            })
                            .catch(error => {
                                this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                                this.modal.infoType = this.modal.types.ERROR;
                                this.showModal(this.modal.types.INFO);
                            });
                        return
                    }

                    if (response?.data?.result?.successERPIntegrated == false || response?.data?.result?.successQuotationIntegrated == false) {
                        this.modal.infoType = this.modal.types.APPROVE_WITH_WARNING;
                    }

                    this.temporaryIdForOrder = response.data.result.id;
                    if (this.modalGoToPlanning.goToPlanning) {
                        let payload = {
                            quotationId: response.data.result.id,
                            cameFromBudget: true,
                            cameFromHistory: false,
                            plate: this.checkPlate,
                            internalId: null,
                            dataSourceId: this.$store.getters['vehicleIdentification/getState'].dataSourceId
                        }
                        this.$store.commit('planning/setPlanningBudgetState', payload);
                    }
                })
                .then(response => {
                    if (printDocument) {
                        const file = new Blob([response.data], {type: 'application/pdf'});
                        this.responsePDF = URL.createObjectURL(file);
                    } else {
                        this.responsePDF = null;
                    }
                    this.showModal(this.modal.types.INFO);
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modal.infoType = this.modal.types.ERROR;
                    this.showModal(this.modal.types.INFO);
                    this.catchError = true;
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                    this.onOrderSelectedParts();
                });
        },
        printInPreviewMode(quotationId, payload) {
            let sendEmail = false;
            let printDocument = false;
            if (this.modal.infoType === this.modal.types.SEND_EMAIL) {
                sendEmail = true;
                return QuotationServicesSendEmailAndPDF(quotationId, payload, true)
                    .then(response => {
                        this.responsePDF = 'email';
                        this.showModal(this.modal.types.INFO);
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        this.modal.infoType = this.modal.types.ERROR;
                        this.showModal(this.modal.types.INFO);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    });
            } else if (this.modal.infoType === this.modal.types.PRINT) {
                printDocument = true;
                return QuotationServicesSendEmailAndPDF(quotationId, payload, false)
                    .then(response => {
                        if (printDocument) {
                            const file = new Blob([response.data], {type: 'application/pdf'});
                            this.responsePDF = URL.createObjectURL(file);
                            window.open(this.responsePDF);
                        } else {
                            this.responsePDF = null;
                        }
                        //this.showModal(this.modal.types.INFO);
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        this.modal.infoType = this.modal.types.ERROR;
                        this.showModal(this.modal.types.INFO);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    });
            }
        },
        // MODAL FINAL
        async modalInfoOkClicked() {
            /**
             * Caso aconteça algum erro é excluido o carrinho e
             * redirecionado para o step 1
             */
            this.modal.show = false;
            let processNummber = this.$store.getters['vehicleIdentification/getState'].processNumber;


            if (this.$route.name === 'budget-summary-preview') {
                this.modal.show = false;
                if (this.responsePDF !== null) {
                    if (this.responsePDF !== 'email') {
                        window.open(this.responsePDF);
                    }
                }
                return;
            }

            if (!this.computedCheckForPlanningModule && this.modal.infoType === 'save') {
                if (this.$route.name === 'budget-summary' || this.$route.name === 'budget-summary-edit') {
                    this.modal.show = false;
                    this.modalAskForStayOnThePage.show = true;
                    return;
                }
            }

            if (this.modal.infoType === 'save' && this.computedCheckForPlanningModule) {
                if (this.catchError) {
                    localStorage.removeItem('@datadrive:planning-event');
                    let payload = {
                        quotationId: null,
                        cameFromBudget: false,
                        cameFromHistory: false,
                        plate: null,
                        internalId: null,
                        dataSourceId: null
                    }
                    this.$store.commit('planning/setPlanningBudgetState', payload);
                    this.$store.commit('planning/setPlanningEvent', {})
                    this.clearShoppingCart();
                    return;
                }
                const payloadBudgetStartedBy = {budgetId: null, budgetName: ''}
                this.$store.commit('budget/setBudgetStartedBy', payloadBudgetStartedBy);

                const hasQuotationByActiveReception = this.$store.getters['activeReception/getActiveReceptionServicesAssociatedQuotationId'];
                if (hasQuotationByActiveReception !== null) {
                    return;
                }

                const hasAnyPlanningLocalStorage = JSON.parse(localStorage.getItem('@datadrive:planning-event'));
                if (!hasAnyPlanningLocalStorage) {
                    this.modalAskForPlanning.title = this.$t('module-budget.main-budget.modal-ask-plan.title1');
                    this.modalAskForPlanning.message = this.$t('module-budget.main-budget.modal-ask-plan.message1');
                    this.modalAskForPlanning.show = true;
                    this.modalAskForPlanning.id = 1;
                    return;
                } else {
                    if (hasAnyPlanningLocalStorage.isCreate) {
                        this.modalAskForPlanning.title = this.$t('module-budget.main-budget.modal-ask-plan.title1');
                        this.modalAskForPlanning.message = this.$t('module-budget.main-budget.modal-ask-plan.message2');
                        this.modalAskForPlanning.show = true;
                        this.modalAskForPlanning.id = 2;
                        return;
                    } else if (this.hasPlanningId !== null && this.hasPlanningId !== undefined) {
                        this.modalAskForPlanning.title = this.$t('module-budget.main-budget.modal-ask-plan.title2');
                        this.modalAskForPlanning.message = this.$t('module-budget.main-budget.modal-ask-plan.message3')
                        this.modalAskForPlanning.show = true;
                        this.modalAskForPlanning.id = 3;
                        return;
                    } else {
                        this.modalAskForPlanning.title = this.$t('module-budget.main-budget.modal-ask-plan.title2');
                        this.modalAskForPlanning.message = this.$t('module-budget.main-budget.modal-ask-plan.message2');
                        this.modalAskForPlanning.show = true;
                        this.modalAskForPlanning.id = 4;
                        return;
                    }
                }
            }

            if (this.modal.type !== this.modal.types.SEND_EMAIL && this.responsePDF === null) {
                if (this.sendEmail) {
                    this.sendEmail = false;
                    return;
                } else if (this.modal.infoType == 'approve-with-warning' && this.rejectedQuotation == true) {
                    this.clearShoppingCart();
                }
                this.$store.commit('budget/setB2bClearShoppingCart');
                this.$store.commit('budget/setB2bCurrentStep', 1);

                this.$store.commit('budget/setCurrentProcessNumberByCar', processNummber);
                this.$store.commit('budget/setClearBudgetSummary', {});

                const shoppingCartTotals = {
                    operations: {totals: {}},
                    parts: {totals: {}}
                }
                this.$store.commit('budget/setShoppingCartTotalsClear', shoppingCartTotals);
                localStorage.removeItem('@shoppingCartTotals');

                await this.$helpers.handleRenewProcessNumber(this.forceResolveVehicle);

                if (this.catchError) {
                    localStorage.removeItem('@datadrive:planning-event');
                    let payload = {
                        quotationId: null,
                        cameFromBudget: false,
                        cameFromHistory: false,
                        plate: null,
                        internalId: null,
                        dataSourceId: null
                    }
                    this.$store.commit('planning/setPlanningBudgetState', payload);
                    this.$store.commit('planning/setPlanningEvent', {})
                    this.clearShoppingCart();
                    return;
                }

                // if(this.newPlate){
                //     this.clearShoppingCart(true);
                //     this.plateSearch(null, this.newPlate, null)
                // } else {
                if (this.modalAlertToLeave.needToRedirect) {
                    const checkClickedRoute = this.$store.getters['sidebarActiveMenu/getStateSidebarActiveMenu'].routeSidebar
                    this.clearShoppingCart(true);
                    if (checkClickedRoute === '/') {
                        localStorage.clear();
                        this.$cookies.remove('token', {secure: true, expires: 1});
                        this.$store.commit('auth/setState', {});
                        this.$store.commit('vehicleIdentification/setVehicleIdentificationClear');
                        this.$router.push('/');
                        location.reload();
                    } else {
                        document.location = checkClickedRoute;
                    }
                } else {
                    const budgetStartedBy = this.$store.getters['budget/getBudgetStartedBy'];

                    const payloadBudgetStartedBy = {
                        budgetId: null,
                        budgetName: ''
                    }
                    this.$store.commit('budget/setBudgetStartedBy', payloadBudgetStartedBy);

                    const hasAnyPlanningLocalStorage = JSON.parse(localStorage.getItem('@datadrive:planning-event'));
                    if (this.modalGoToPlanning.goToPlanning) {
                        if (hasAnyPlanningLocalStorage) {
                            if (!hasAnyPlanningLocalStorage.isCreate) {
                                this.$store.commit("planning/setNewPlanningEvent", {
                                    planningId: hasAnyPlanningLocalStorage.eventRecord.planningId
                                });
                                this.$router.push({
                                    name: 'edit-planning',
                                    params: {planningId: hasAnyPlanningLocalStorage.eventRecord.planningId}
                                });
                                return;
                            }
                        }
                        this.$router.push({name: 'planning'});
                    } else if (budgetStartedBy?.budgetName == 'planning-module') {
                        if (hasAnyPlanningLocalStorage) {
                            if (!hasAnyPlanningLocalStorage.isCreate) {
                                this.$store.commit("planning/setNewPlanningEvent", {
                                    planningId: hasAnyPlanningLocalStorage.eventRecord.planningId,
                                    quotationId: this.newQuotationId
                                });
                                this.$router.push({
                                    name: 'edit-planning',
                                    params: {planningId: hasAnyPlanningLocalStorage.eventRecord.planningId}
                                });
                                return;
                            }
                        }
                        this.$router.push({name: 'planning', params: {quotationId: this.newQuotationId}});
                    } else if (this.computedCheckForPlanningModule && this.modal.infoType !== 'reject') {
                        const hasBudgetOnLocalStorage = JSON.parse(localStorage.getItem('@datadrive:planning-event'));
                        this.showTotalizers = false;
                        this.modalAskForPlanning.message = this.$t('module-budget.main-budget.modal-ask-plan.message1');
                        if (this.hasPlanningId !== null && this.hasPlanningId !== undefined) {
                            this.modalAskForPlanning.title = this.$t('module-budget.main-budget.modal-ask-plan.title2');
                            this.modalAskForPlanning.message = this.$t('module-budget.main-budget.modal-ask-plan.message3')
                        }
                        if (hasBudgetOnLocalStorage) {
                            if (!hasBudgetOnLocalStorage.eventRecord.quotationId) {
                                if (hasBudgetOnLocalStorage.isCreate) {
                                    this.showTotalizers = false;
                                    this.modalAskForPlanning.message = this.$t('module-budget.main-budget.modal-ask-plan.message2');
                                }
                            }
                        }
                        this.modalAskForPlanning.show = true;
                        this.modalAskForPlanning.id = 5;
                        const hasQuotationIdByActiveReception = this.$store.getters['activeReception/getActiveReceptionServicesAssociatedQuotationId'];
                        if (hasQuotationIdByActiveReception !== null) {
                            this.$store.commit('activeReception/setActiveReceptionServicesAssociatedQuotationId', null);
                            this.$router.push({name: 'dashboard'});
                        }
                    } else {
                        localStorage.removeItem('@datadrive:planning-event');
                        let payload = {
                            quotationId: null,
                            cameFromBudget: false,
                            cameFromHistory: false,
                            plate: null,
                            internalId: null,
                            dataSourceId: null
                        }
                        this.$store.commit('planning/setPlanningBudgetState', payload);
                        this.$store.commit('planning/setPlanningEvent', {})
                        this.$router.push({name: 'dashboard'});
                    }
                }
                //}
            } else {
                if (this.responsePDF !== null) {
                    if (this.responsePDF !== 'email') {
                        window.open(this.responsePDF);
                    }
                }
            }
        },
        sendBudgetDataToBackend(userActionData, callback = null, hasQuotationId = false) {
            let backendPayload = this.buildBackendPayload(userActionData);

            let quotationId = this.$route.params.id;

            const getStateOfActiveReception = this.$store.getters['activeReception/getActiveReceptionServicesAssociatedQuotationId']
            if (getStateOfActiveReception !== null) {
                quotationId = getStateOfActiveReception
            }

            if (!quotationId) {
                const getUrl = location.href;
                const splitUrl = getUrl.split('/');
                const lastElement = splitUrl[splitUrl.length - 1];
                if (lastElement === 'edit') {
                    const quotationNumber = +splitUrl[splitUrl.length - 2];
                    if (!isNaN(quotationNumber)) {
                        quotationId = quotationNumber;
                    }
                }
            }

            return new Promise((resolve, reject) => {
                QuotationServicesSendBudgetInfo(backendPayload, quotationId)
                    .then(response => {
                        resolve(response);
                        if (callback) callback(response.data.result.id, !hasQuotationId);
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        console.error(error);
                        reject(error);
                    });
            });
        },
        /**
         * this method should be here. should be a transform file, that is called from within the service.
         * this file should have access to the store and build the payload there. shouldn't be locally
         */
        buildBackendPayload(userActionData) {
            let backendPayload = {
                ...userActionData,
                quotationWorks: buildQuotationWorks(this),
                quotationParts: buildQuotationParts(this),
                quotationMargins: this.computedBudgetSummary.quotationMargins ? buildQuotationMargins(this) : {},
                quotationValueOE: buildQuotationOE(this),
                observations: this.observationsQuotation
            };

            const hasAnyIamPart = this.computedBudgetSummary.parts.values.some(part => part.isIam);
            if (hasAnyIamPart) {
                backendPayload.quotationValueIAM = buildQuotationIAM(this);
            }

            return backendPayload;

            function buildQuotationWorks(context) {
                /**
                 {
                 "workId": "string",
                 "itemMpId": "string",
                 "reference": "string",
                 "quotationLaborId": 0,
                 "discountMobyLine": 0,
                 "partialPriceMO": 0
                 }
                 */
                const t = _.cloneDeep(context.computedBudgetSummary.operations)
                return t.values.map(operation => {
                    let cloneTheOperation = _.cloneDeep(operation);
                    let operationNew = operation;
                    let inclusiveWorks = [];
                    if (operationNew.names.length > 0) {
                        operationNew.names.shift();
                        operationNew.names.forEach(element => {
                            let newElement = {
                                workPosText: element,
                            }
                            inclusiveWorks.push(newElement)
                        });
                    }

                    let setQuotationLaborOEId = operation.hourValue.quotationLaborId;
                    ;
                    let setQuotationLaborIAMId = null;

                    if (operation.hourValue.isIAM == true) {
                        setQuotationLaborIAMId = operation.hourValue.quotationLaborId;
                        setQuotationLaborOEId = operation.hourValueDefault.oe.quotationLaborId;
                    }

                    let description = '';
                    if (cloneTheOperation.workPosDescription && cloneTheOperation.workPosDescription !== "") {
                        description = cloneTheOperation.workPosDescription
                    } else if (cloneTheOperation.description && cloneTheOperation.description !== "") {
                        description = cloneTheOperation.description
                    } else if (cloneTheOperation.names && cloneTheOperation.names.length > 0) {
                        description = cloneTheOperation.names[0];
                    }

                    return {
                        workId: operation.workId,
                        itemMpId: operation.itemMpId,
                        reference: operation.reference,
                        quotationLaborOEId: setQuotationLaborOEId,
                        quotationLaborIAMId: setQuotationLaborIAMId,
                        discountMobyLine: operation.discount,
                        partialPriceMO: operation.totalWithoutVAT,
                        description: description,
                        originalTime: operation.calculatedTime ? +operation.calculatedTime : 0,
                        inclusiveWorkPositions: inclusiveWorks,
                        korId: operation.korId ? operation.korId : '',
                    };
                });
            }

            function buildQuotationParts(context) {
                /**
                 {
                 "itemMpId": "string",
                 "reference": "string",
                 "editedPrice": 0,
                 "discountPartsByLine": 0,
                 "price": 0,
                 "isIam": true,
                 "quantity": "string"
                 }
                 */

                return context.computedBudgetSummary.parts.values.map(part => {
                    return {
                        itemMpId: part.itemMpId,
                        reference: part.reference,
                        editedPrice: part.price,
                        discountPartsByLine: part.discount,
                        price: part.totalWithoutVAT,
                        costPrice: part.costPrice,
                        isIam: part.isIam,
                        quantity: part.quantity,
                        description: part.name ? part.name : '',
                        brandId: part.brandId && !(context.isIamWithoutSM && part.isIam) ? part.brandId : '',
                        brandDescription: part.brand ? part.brand : '',
                        workId: part.workId && !(context.isIamWithoutSM && part.isIam) ? part.workId : '',
                        partId: part.partId ? part.partId : '',
                        additionalDescription: part.aditionalDescription,
                        quotationPartId: part.quotationPartId,
                    };
                });
            }

            function buildQuotationMargins(context) {
                return {
                    moCostPrice: context.computedBudgetSummary.quotationMargins.moCostPrice,
                    moSellPrice: context.computedBudgetSummary.quotationMargins.moSellPrice,
                    moMargin: context.computedBudgetSummary.quotationMargins.moMargin,
                    moMarginPercentage: context.computedBudgetSummary.quotationMargins.moMarginPercentage,
                    partCostPrice: context.computedBudgetSummary.quotationMargins.partCostPrice,
                    partSellPrice: context.computedBudgetSummary.quotationMargins.partSellPrice,
                    partMargin: context.computedBudgetSummary.quotationMargins.partMargin,
                    partMarginPercentage: context.computedBudgetSummary.quotationMargins.partMarginPercentage,
                    iamOperationCost: context.computedBudgetSummary.quotationMargins.iamOperationCost,
                    iampvp: context.computedBudgetSummary.quotationMargins.iampvp,
                    iamMargin: context.computedBudgetSummary.quotationMargins.iamMargin,
                    iamMarginPercentage: context.computedBudgetSummary.quotationMargins.iamMarginPercentage
                }

            }

            function buildQuotationIAM(context) {
                const operationsTotals = context.computedBudgetSummary.operations.totals;
                const partsTotals = context.computedBudgetSummary.parts.totals;
                const iamTotals = context.computedBudgetSummary.totals.iam;
                return {
                    subTotalHoursMO: operationsTotals.totalDuration.hours + '.' + operationsTotals.totalDuration.minutes,
                    subTotalValueMO: operationsTotals.totalWithoutDiscount,
                    subTotalDiscountMO: operationsTotals.globalDiscount,
                    netTotalMO: operationsTotals.totalWithDiscount,

                    subTotalValueParts: partsTotals.totalWithoutDiscount,
                    subTotalDiscountParts: partsTotals.globalDiscount,
                    netTotalParts: partsTotals.totalWithDiscount,

                    totalSIVA: iamTotals.totalWithoutVAT,
                    ivAtotal: iamTotals.vat,
                    totalCIVA: iamTotals.total
                };
            }

            function buildQuotationOE(context) {
                const operationsTotals = context.computedBudgetSummary.operations.totals;
                const subTotalDiscountParts = context.computedBudgetSummary.parts.totals.globalDiscount;
                const totalSIVA = context.$options.filters.currency(context.computedBudgetSummary.totals.oe.totalWithoutVAT, true, false);
                const ivAtotal = context.$options.filters.currency(context.computedBudgetSummary.totals.oe.vat, true, false);
                const totalCIVA = context.$options.filters.currency(context.computedBudgetSummary.totals.oe.total, true, false);

                return {
                    subTotalHoursMO: operationsTotals.totalDuration.hours + '.' + operationsTotals.totalDuration.minutes,
                    subTotalValueMO: context.$options.filters.currency(operationsTotals.totalWithoutDiscount, true, false),
                    subTotalDiscountMO: operationsTotals.globalDiscount,
                    netTotalMO: context.$options.filters.currency(operationsTotals.totalWithDiscount, true, false),

                    subTotalValueParts: context.$options.filters.currency(context.computedBudgetSummary.parts.totals.totalOeOnlyWithoutDiscount ? context.computedBudgetSummary.parts.totals.totalOeOnlyWithoutDiscount : context.computedBudgetSummary.parts.totals.totalOeOnlyWithDiscount, true, false),
                    subTotalDiscountParts: subTotalDiscountParts,
                    netTotalParts: context.$options.filters.currency(+context.computedBudgetSummary.parts.totals.totalOeOnlyWithDiscount, true, false),

                    totalSIVA: totalSIVA,
                    ivAtotal: ivAtotal,
                    totalCIVA: totalCIVA
                };
            }
        },
        roundExactMethod(num, places) {
            if (!("" + num).includes("e")) {
                return +(Math.round(num + "e+" + places) + "e-" + places);
            } else {
                let arr = ("" + num).split("e");
                let sig = "";
                if (+arr[1] + places > 0) {
                    sig = "+";
                }
                return +(
                    Math.round(+arr[0] + "e" + sig + (+arr[1] + places)) +
                    "e-" +
                    places
                );
            }
        },
        updateTotalOeOnlyValue() {
            function calculateFinalRowPrice(priceXquantity, discount) {
                return discount > 0
                    ? +priceXquantity * (1 - discount / 100)
                    : +priceXquantity;
            }

            this.$store.commit('budget/setBudgetSummaryPartsTotalOeOnlyWithDiscount', +this.$refs.partsRow.reduce((acc, value) => {
                const getPrice = value.selectedPart.price;
                let getQuantity = value.selectedPart.quantities.find(e => e.isSelected);
                let getDiscount = value.selectedPart.discount;
                if (getQuantity) {
                    getQuantity = getQuantity.quantity;
                } else {
                    getQuantity = value.selectedQuantity.quantity;
                }
                let priceXquantityInCents = +(getPrice * getQuantity);
                let finalRowPriceInCents = calculateFinalRowPrice(priceXquantityInCents, getDiscount);
                finalRowPriceInCents = this.$options.filters.currency(finalRowPriceInCents, true, false)
                return acc + finalRowPriceInCents;
            }, 0));
        },
        onOkModalRequestCliked() {
            this.modalRequest.show = false;
            this.clearShoppingCart();
        },
        closeOrderModalRequestCliked() {
            this.modal.show = false;
            this.showModalOrder.show = false;

            this.selectedOrderParts = []
        },
        compareArrays(a1, a2) {
            let a = [];
            let diff = [];

            for (var i = 0; i < a1.length; i++) {
                a[a1[i]] = true;
            }

            for (var i = 0; i < a2.length; i++) {
                if (a[a2[i]]) {
                    delete a[a2[i]];
                } else {
                    a[a2[i]] = true;
                }
            }

            for (var k in a) {
                diff.push(k);
            }

            return diff;
        },
        onAddOperationClicked() {
            this.modalAddOperationOrPart.isOperation = true;
            this.modalAddOperationOrPart.show = true;
        },
        onAddPartClicked() {
            this.modalFreePart.show = true;
        },
        onCloseAddModal() {
            this.modalAddOperationOrPart.isPart = false;
            this.modalAddOperationOrPart.isOperation = false;
            this.modalAddOperationOrPart.show = false;

            this.modalFreeOperation.newPosition.reference = '';
            this.modalFreeOperation.newPosition.names[0] = '';
            this.modalFreeOperation.newPosition.durationComplete = '';
            this.modalFreeOperation.newPosition.description = '';
            this.modalFreeOperation.show = false;

            this.modalFreePart.show = false;
            this.modalFreePart.notFound = false;

            this.modalFreePart.searchMethod = 0
        },
        onAddFreePosition() {
            this.modalAddOperationOrPart.show = false;
            this.modalFreeOperation.show = !!this.modalAddOperationOrPart.isOperation;
            this.modalFreePart.show = !!this.modalAddOperationOrPart.isPart;
        },
        onOkClickedFreeOperation() {
            this.modalAddOperationOrPart.isPart = false;
            this.modalAddOperationOrPart.isOperation = false;
            this.modalAddOperationOrPart.show = false;
            this.modalFreeOperation.show = false;
            this.modalFreePart.show = false;
            this.modalFreePart.notFound = false;

            // Give right hour
            let labor = this.$store.getters['budget/getB2bLaborValues']
            const getLaborValuesOe = labor.find(labor => labor.isActive && labor.isFavourite && !labor.isIAM);
            const getLaborValuesIam = labor.find(labor => labor.isActive && labor.isFavourite && labor.isIAM);
            this.modalFreeOperation.newPosition.hourValue = this.computedBudgetSummary.operations.values[0].hourValue;

            this.modalFreeOperation.newPosition.hourValueDefault.oe = getLaborValuesOe;
            this.modalFreeOperation.newPosition.hourValueDefault.iam = getLaborValuesIam;

            // Give random workId and itemMpId
            let initialNumber = '-111';
            let newWorkId = (Math.random() * 1000).toFixed(0);
            let newMpItemId = (Math.random() * 1000).toFixed(0);

            // Give a right original time
            let splitDurationComplete = this.modalFreeOperation.newPosition.durationComplete.split(':');
            let timeOriginal = splitDurationComplete[0] + '.' + splitDurationComplete[1];
            this.modalFreeOperation.newPosition.duration.hours = splitDurationComplete[0];
            this.modalFreeOperation.newPosition.duration.minutes = splitDurationComplete[1];
            this.modalFreeOperation.newPosition.calculatedTime = +timeOriginal;

            // Give ID changes
            this.modalFreeOperation.newPosition.workId = initialNumber + newWorkId;
            this.modalFreeOperation.newPosition.itemMpId = initialNumber + newMpItemId;

            // Give Description
            if (this.modalFreeOperation.newPosition.description !== '') {
                let newInclusiveWorkPosition = {
                    workPosText: this.modalFreeOperation.newPosition.description,
                }
                this.modalFreeOperation.newPosition.inclusiveWorkPositions.push(newInclusiveWorkPosition);
                this.modalFreeOperation.newPosition.names.push(newInclusiveWorkPosition.workPosText);

                this.modalFreeOperation.newPosition.description = this.modalFreeOperation.newPosition.names[0];

            } else {
                this.modalFreeOperation.newPosition.description = this.modalFreeOperation.newPosition.names[0];
            }

            if (this.modalFreeOperation.newPosition.singleWorkTime == 0) {
                this.modalFreeOperation.newPosition.singleWorkTime = +timeOriginal;
            }

            let newRow = this.modalFreeOperation.newPosition;

            this.operations.push(newRow);

            let op = this.operations;
            op = op.map(item =>
                Object.assign(item, {
                    workPosDescription: item.names[0],
                    workPosCriteriaDescription: item.names[0],
                    singleWorkTime: +item.duration.hours == 0 ? +item.calculatedTime : +item.duration.hours,
                    totalWorkTime: +item.duration.minutes
                })
            );

            let payload = {
                item: newRow,
                type: 'maintenance'
            }

            this.$store.commit('budget/setB2bRemoveOrAddShoppingCartItem', payload);
            if (newRow.hourValue.isIAM) {
                this.$store.commit('budget/setBudgetPayloadForTotalizersCalcsIAM', newRow);

                let labor = this.$store.getters['budget/getB2bLaborValues'];
                let newRowClone = _.cloneDeep(newRow);
                newRowClone.hourValue = labor.find(e => !e.isIAM && e.isFavourite && e.isActive);

                this.$store.commit('budget/setBudgetPayloadForTotalizersCalcsOE', newRowClone);

            } else {
                this.$store.commit('budget/setBudgetPayloadForTotalizersCalcsOE', newRow);
            }

            this.modalFreeOperation.newPosition = {
                discount: 0,
                duration: {hours: '0', minutes: '0'},
                hourValue: {},
                itemMpId: '',
                names: [''],
                freeReference: true,
                reference: '',
                singleWorkTime: 0,
                totalWorkTime: 0,
                workId: '',
                workPosDescription: '',
                workPosCriteriaDescription: '',
                workTime: 0,
                description: '',
                calculatedTime: 0,
                inclusiveWorkPositions: [],
                durationComplete: '',
                hourValueDefault: {oe: {}, iam: {}}
            };
        },
        onOkClickedFreePart() {
            this.modalAddOperationOrPart.isPart = false;
            this.modalAddOperationOrPart.isOperation = false;
            this.modalAddOperationOrPart.show = false;
            this.modalFreeOperation.show = false;
            this.modalFreePart.show = false;
            this.modalFreePart.notFound = false;

            if (this.modalFreePart.searchMethod === 2) {
                // Give random itemMpId
                let initialNumber = '-111';
                let newMpItemId = (Math.random() * 1000).toFixed(0);
                // Give ID changes
                this.modalFreePart.newPart[0].itemMpId = initialNumber + newMpItemId;
            }

            let partt = this.modalFreePart.newPart;
            let resultParts = {};
            let newArray = [];
            partt.forEach((findPart, index) => {
                resultParts = {
                    discount: 0,
                    iamParts: findPart.iamParts
                        ? findPart.iamParts
                            .sort((a, b) => (a.partPrice > b.partPrice ? 1 : -1)) // sort ascending price
                            .map((iamPart, iamIndex) => {
                                return {
                                    itemMpId: findPart.itemMpId,
                                    isSelected: iamIndex === 0,
                                    reference: iamPart.partNo,
                                    brand: iamPart.partBrandDescription,
                                    name: iamPart.partDescription,
                                    price: iamPart.partPrice,
                                    costPrice: iamPart.costPrice,
                                    quantity: 1
                                };
                            })
                        : [],
                    isIam: false,
                    isSelected: true,
                    itemMpId: findPart.itemMpId,
                    name: findPart.partQualColText ? findPart.partQualColText : findPart.itemMpText,
                    price: findPart.partPrice,
                    costPrice: findPart.costPrice,
                    quantities: findPart.amounts.map((quantity, quantityIndex) => {
                        return {
                            id: quantity.itemMpId,
                            quantity: quantity.amount,
                            isSelected: quantityIndex === 0
                        };
                    }),
                    reference: findPart.partNo,
                    freeReference: findPart.freeReference ? findPart.freeReference : true,
                    apiPartOrder: findPart.apiPartOrder ? findPart.apiPartOrder : index + 1

                };
                newArray.push(resultParts);
            });
            if (_.isEmpty(this.parts)) {
                let part = {};
                part[newArray[0].itemMpId] = newArray;
                this.parts = {
                    ...this.parts,
                    ...part
                };
                this.$store.commit('budget/setMaintenanceShoppingCartParts', this.parts);
            } else {
                const partExists = Object.values(this.parts).some(partArray => partArray[0].itemMpId == newArray[0].itemMpId);

                if (partExists) {
                    this.modalFreePart.isExists = true;
                    this.modalFreePart.valid = false;
                    this.modalFreePart.foundPart.show = false;
                    this.modalFreePart.notFound = false;
                    this.modalFreePart.loading = false;
                    this.modalFreePart.show = true;
                    return;
                } else {
                    let part = {};
                    part[newArray[0].itemMpId] = newArray;
                    this.parts = {
                        ...this.parts,
                        ...part
                    };
                    this.$store.commit('budget/setMaintenanceShoppingCartParts', this.parts);
                }
            }

            this.modalFreePart = {
                show: false,
                valid: false,
                valid2: false,
                referenceSearch: '',
                notFound: false,
                isExists: false,
                loading: false,
                foundPart: {
                    show: false,
                    message: ''
                },
                newPart: [{
                    itemMpText: '',
                    tips4yQuantity: 1,
                    partPrice: 0,
                    costPrice: 0,
                    amounts: [{
                        amount: '',
                        isOnlyForReference: false,
                        itemMpId: 0,
                        qualColId: 0,
                        quantity: ""
                    }],
                    iamParts: [],
                    itemMpId: '',
                    freeReference: true,
                    apiPartOrder: (this.sortedParts.length - 1) + 1
                }],
                searchMethod: 0,
            }
        },
        searchPartByReference(partNo) {
            this.modalFreePart.valid = false;
            this.modalFreePart.isExists = false;
            this.modalFreePart.notFound = false;
            this.modalFreePart.loading = true;

            let internalID = '';
            if (this.computedLastBudget) {
                internalID = this.computedLastBudget.internalId;
            }

            QuotationServicesGetAdditionalMaintenanceParts(partNo, internalID)
                .then(response => {
                    this.modalFreePart.loading = false;
                    this.modalFreePart.newPart = response.data.result;
                    this.modalFreePart.notFound = false;
                    this.modalFreePart.valid = true;
                    this.modalFreePart.foundPart.show = true;
                    this.modalFreePart.foundPart.message = `${this.$t('module-budget.main-budget.modal-add-part-form.found-part1')}${response.data.result[0].itemMpText}${this.$t('module-budget.main-budget.modal-add-part-form.found-part2')}`;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalFreePart.valid = false;
                    this.modalFreePart.isExists = false;
                    this.modalFreePart.loading = false;
                    this.modalFreePart.notFound = true;
                    console.error('Error on search part by reference - budget summary b2b', error);
                })
                .finally(() => {
                });
        },
        onClickToPredefinedOperation() {
            this.$router.push({name: 'budget_repair_graphic'});
        },
        async modalShowOrder() {
            const partsClone = this.parts;
            let newArrayOfParts = [];

            for (let key in partsClone) {
                let internArray = partsClone[key];
                let element = internArray.find(o => o.isSelected);
                let refOE = element.reference;
                let refIAM = element.reference;
                let quantity = element.quantities.find(e => e.isSelected).quantity
                let brand = '';
                let brandId = '';
                let theName = element.name;

                if (element.isIam) {
                    if (element.iamParts && element.iamParts.length > 0) {
                        const findSelected = element.iamParts.find(p => p.isSelected == true);
                        if (findSelected) {
                            refIAM = findSelected.reference ? findSelected.reference : '';
                            quantity = findSelected.quantity ? findSelected.quantity : 1;
                            brand = findSelected.brand ? findSelected.brand : '';
                            brandId = findSelected.brandId ? findSelected.brandId : '';
                            theName = findSelected.name ? findSelected.name : element.name
                        }
                    }
                } else {
                    this.computedBudgetSummary.parts.values.forEach(part => {
                        if (element.itemMpId == part.itemMpId) {
                            theName = part.name ? part.name : element.name;
                            refOE = part.reference ? part.reference : element.reference;
                        }
                    })
                }

                let newObj = {
                    ...element,
                    name: theName,
                    referenceOE: refOE,
                    referenceIAM: element.isIam && element.isIam !== '' ? refIAM : '',
                    brand: brand,
                    quantity: quantity,
                    qtd: String(quantity),
                    brandId: brandId,
                    isIam: element.isIam && element.isIam !== ''
                }

                if (this.checkIfFluid(newObj) == true) {
                    if (this.checkIfIsEcolub(newObj) == false) {
                        newArrayOfParts.push(newObj);
                    }
                } else {
                    if (this.checkIfIsEcolub(newObj) == false) {
                        newArrayOfParts.push(newObj)
                    }
                }
            }
            await this.$nextTick();
            this.showModalOrder.parts = newArrayOfParts;
            this.showModalOrder.show = true;
            this.callContactoOrderPartAbove();
        },
        checkIfIsEcolub(part) {
            return String(part.itemMpId).includes('-999');
        },
        checkIfIsPackageService(part) {
            return String(part.workId).includes('-998');
        },
        checkIfIsFreePart(part) {
            return String(part.itemMpId).includes('-111');
        },
        onOrderSelectedParts() {
            this.showModalOrder.show = false;

            if (this.selectedOrderParts.length === 0) {
                const shoppingCartCopy = {
                    operations: [],
                    parts: [],
                }
                this.$store.commit('budget/setShoppingCartCopy', shoppingCartCopy);
                localStorage.removeItem('@copyShoppingCart');
                return;
            }

            let quotationId = this.temporaryIdForOrder;
            let orderParts = this.selectedOrderParts.map(element => Object.assign({
                referenceOE: element.referenceOE,
                referenceIAM: element.referenceIAM,
                isIam: element.isIam ? element.isIam : false,
                brandID: element.brandId ? element.brandId : '',
                brandDescription: element.brand ? element.brand : this.computedBrandOfVehicle,
                description: element.name ? element.name : '',
                quantity: element.qtd ? Number(element.qtd) : 0
                })
            );

            let newArrayOrderParts = [];
            orderParts.map(e => {
                newArrayOrderParts.push(e);
            })

            let body = {
                'orderPartEmail': this.orderIamEmail,
                'orderParts': newArrayOrderParts
            };

            return QuotationServicesOrderParts(quotationId, body)
                .then(response => {
                    // console.log('Response: ', response.data);
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modal.infoType = this.modal.types.ERROR;
                    this.showModal(this.modal.types.INFO);
                })
                .finally(() => {
                    const shoppingCartCopy = {
                        operations: [],
                        parts: [],
                    }
                    this.$store.commit('budget/setShoppingCartCopy', shoppingCartCopy);
                    localStorage.removeItem('@copyShoppingCart');
                });
        },
        onClickToSave() {
            this.modalAskForSave.show = false;
            this.showModal(this.modal.types.SAVE)
        },
        onClickToSaveSchedulingModal() {
            this.modalGoToPlanning.show = false;
            this.modalGoToPlanning.goToPlanning = true;
            this.showModal(this.modal.types.SAVE)
        },
        getBudgetStartedByName() {
            return this.$store.getters['budget/getBudgetStartedBy'].budgetName;
        },
        onTypeSearchClicked(id) {
            this.modalFreePart.searchMethod = id;
            this.modalFreePart.referenceSearch = '';
            this.modalFreePart.isExists = false;
            this.modalFreePart.loading = false;
            this.modalFreePart.foundPart.show = false;
            this.modalFreePart.valid = false;
            this.modalFreePart.newPart = [{
                partNo: '',
                itemMpText: '',
                tips4yQuantity: 1,
                partPrice: '0.00',
                costPrice: '0.00',
                amounts: [{
                    amount: '',
                    isOnlyForReference: false,
                    itemMpId: 0,
                    qualColId: 0,
                    quantity: ""
                }],
                iamParts: [],
                itemMpId: '',
                freeReference: true,
                apiPartOrder: (this.sortedParts.length - 1) + 1
            }];
        },
        resolveFreeOperationsAndParts(activeReceptionFlag, idToDelete, endpointResponse, itemMpIdToRemoveFromPart) {
            /** Search for Free Operation to add in table
             * Because when you hit the endpoint that the parts and operations are looking for,
             * the id of the free operation does not exist in the DB,
             * because it is generated randomly on the frontend side
             * (something to be corrected later) so you have to find that free piece and add it to the hand.
             */

            let budgetOp = this.computedCurrentShoppingCart.operations.maintenance.map(el => el);
            budgetOp.forEach((element, index) => {
                if (element.freeReference) {
                    let freeOp = this.computedCurrentShoppingCart.operations.maintenance.filter(
                        el => el.itemMpId == budgetOp[index].itemMpId
                    );
                    this.operations.push(freeOp[0]);
                }
            });
            // --------- end

            // Search for Free Part
            let flat = _.flatMap(this.computedCurrentShoppingCart.parts);
            let budgetParts = flat.map(el => el);
            budgetParts.forEach((element, index) => {
                if (element.freeReference) {
                    let freePart = flat.filter(el => el.itemMpId == budgetParts[index].itemMpId);
                    let newArrPart = []
                    newArrPart[freePart[0].itemMpId] = freePart;
                    this.parts = {
                        ...this.parts,
                        ...newArrPart
                    };
                }

                if (element.iamParts) {
                    element.iamParts.forEach((item, index) => {
                        if (item.freeIamPart) {
                            let itemMpId = item.itemMpId;
                            let indexIamPart = this.parts[itemMpId].findIndex(e => e.isSelected === true);
                            if (indexIamPart !== -1) {
                                this.parts[itemMpId][indexIamPart].iamParts.push(item);
                            }
                        }
                    })
                }
            });
            // --------- end

            // ----------- Search for free part iam
            let maintenance = this.operations;
            maintenance.map(item => {
                    const calculatedTime = (+item.duration.hours) + '.' + (+item.duration.minutes);
                    Object.assign(item, {
                        workPosDescription: item.names[0],
                        singleWorkTime: +item.duration.hours,
                        totalWorkTime: +item.duration.minutes,
                        calculatedTime: calculatedTime
                    })
                }
            );

            let payload = {
                maintenance: maintenance,
                parts: this.parts,
            };


            Object.filter = function (obj, predicate) {
                let result = {},
                    key;
                for (key in obj) {
                    if (obj.hasOwnProperty(key) && !predicate(obj[key])) {
                        result[key] = obj[key];
                    }
                }
                return result;
            };

            let searchForIam = Object.filter(this.computedCurrentShoppingCart.parts, part => part.isIam === true);
            for (let item in payload.parts) {
                for (let key in searchForIam) {
                    for (let i in payload.parts[item]) {
                        for (let index in searchForIam[key]) {
                            if (searchForIam[key][index] !== null) {
                                if (payload.parts[item][i].itemMpId == searchForIam[key][index].itemMpId) {
                                    if (searchForIam[key][index].isIam == true) {
                                        payload.parts[item][i].isIam = searchForIam[key][index].isIam;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            this.operations = payload.maintenance;
            this.parts = payload.parts;

            const operationResponse = payload.maintenance;
            // --------- end
            // debugger;
            const copyCart = JSON.parse(localStorage.getItem('@copyShoppingCart'));

            if (!copyCart) {
                let frontendPayload = {
                    operations: this.operations,
                    parts: this.parts
                }
                this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
                localStorage.setItem('@copyShoppingCart', JSON.stringify(frontendPayload));
            }

            function findArrayDifference(a1, a2) {
                var a = [], diff = [];
                for (var i = 0; i < a1.length; i++) {
                    a[a1[i]] = true;
                }
                for (var i = 0; i < a2.length; i++) {
                    if (a[a2[i]]) {
                        delete a[a2[i]];
                    } else {
                        a[a2[i]] = true;
                    }
                }
                for (var k in a) {
                    diff.push(k);
                }
                return diff;
            }

            // ---- Find Operations to push to copy cart
            let copyShoppingCart = JSON.parse(localStorage.getItem('@copyShoppingCart'));
            let filterBudgetOp = this.operations.map(el => el.workId);

            let filterCopyCartOp = copyShoppingCart.operations.map(el => el.workId);

            let arraysFiltered = findArrayDifference(filterBudgetOp, filterCopyCartOp);
            let filterOfFilters = [];

            if (Array.isArray(arraysFiltered) && arraysFiltered.length > 0) {
                filterOfFilters.push(arraysFiltered.map(el => {
                    return this.operations.filter(i => i.workId == el)[0]
                }));
                filterOfFilters = filterOfFilters.filter(el => el !== undefined || el !== null)

                if (filterOfFilters.length > 0) {
                    filterOfFilters[0].forEach(element => {
                        if (element !== undefined) {
                            copyShoppingCart.operations.push(element)
                        }
                    });
                }

                if (endpointResponse) {
                    // USE CASE DAT-2783
                    copyShoppingCart.operations.forEach(op => {
                        endpointResponse.operations.forEach(eOp => {
                            if (String(eOp.workId) == String(op.workId) && String(eOp.itemMpId) == String(op.itemMpId) && String(eOp.reference) == String(op.reference)) {
                                if (eOp.calculatedTime) {
                                    const myTime = eOp.calculatedTime;
                                    let durationArray = ['00', '00'];

                                    if (String(myTime).includes('.')) {
                                        durationArray = String(myTime).split('.');
                                    } else {
                                        durationArray = [String(myTime), '00']
                                    }

                                    let hours = durationArray[0];
                                    let minutes = durationArray[1];
                                    if (durationArray && durationArray[0].length <= 1) {
                                        hours = '0' + durationArray[0]
                                    }
                                    if (durationArray && durationArray[1].length <= 1) {
                                        minutes = '0' + durationArray[1]
                                    }

                                    const finalTime = (hours + '.' + minutes);

                                    Object.assign(op, {
                                        singleWorkTime: Number(finalTime),
                                        calculatedTime: Number(finalTime),
                                        duration: {
                                            hours: hours,
                                            minutes: minutes
                                        },
                                    });
                                }
                            }
                        })
                    })
                }
            }

            // --------------------------------------------------

            // ----- Find Parts to push to copy cart

            let partsReference = []
            for (let key in this.parts) {
                partsReference.push(this.parts[key].map(el => el.itemMpId))
            }

            let arrayCopyShoppingCart = copyShoppingCart.parts
            let partsCopyShoppingCartReference = []
            for (let key in arrayCopyShoppingCart) {
                partsCopyShoppingCartReference.push(arrayCopyShoppingCart[key].map(el => el.itemMpId))
            }

            let arraysFilteredParts = findArrayDifference(partsReference, partsCopyShoppingCartReference);

            let partsArray = Object.values(this.parts)

            let allElementPart = []
            if (Array.isArray(arraysFilteredParts) && arraysFilteredParts.length > 0) {

                arraysFilteredParts.map(el => {
                    let splitEl = el.split(',');

                    partsArray.forEach((element, index) => {

                        if (element.length > 1) {
                            allElementPart.push(element.filter(elementA => {
                                for (let k in splitEl) {
                                    if (elementA.itemMpId == splitEl[k]) {
                                        return elementA
                                    }
                                }
                            }));
                        } else {
                            for (let k in splitEl) {
                                if (element[0].itemMpId == splitEl[k]) {
                                    allElementPart.push(element)
                                }
                            }
                        }

                    });
                });

                allElementPart = allElementPart.filter(el => el.length > 0)

                let newFilterParts = {};
                allElementPart.map(el => {
                    newFilterParts[el[0].itemMpId] = el
                })

                copyShoppingCart.parts = {
                    ...copyShoppingCart.parts,
                    ...newFilterParts
                }

            }
            // --------------------------------------

            this.operations = copyShoppingCart.operations;
            this.parts = copyShoppingCart.parts;

            let frontendPayload = {
                operations: this.operations,
                parts: this.parts
            }

            this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
            localStorage.setItem('@copyShoppingCart', JSON.stringify(frontendPayload));

            if (idToDelete) {
                setTimeout(() => {
                    const cloneBudgetSummaryPartsNew = _.cloneDeep(this.computedBudgetSummary.parts.values);
                    let newParts = cloneBudgetSummaryPartsNew.filter(el => String(el.workId) !== String(idToDelete));
                    if (itemMpIdToRemoveFromPart) {
                        newParts = newParts.filter(el => String(el.itemMpId) !== String(itemMpIdToRemoveFromPart));
                    }
                    this.$store.commit('budget/setBudgetSummaryPartsValues', newParts);
                }, 2000);
            }

            this.verifyPartsAndOperationsPrice(activeReceptionFlag);
        },
        findArrayDifference(a1, a2) {
            var a = [], diff = [];
            for (var i = 0; i < a1.length; i++) {
                a[a1[i]] = true;
            }
            for (var i = 0; i < a2.length; i++) {
                if (a[a2[i]]) {
                    delete a[a2[i]];
                } else {
                    a[a2[i]] = true;
                }
            }
            for (var k in a) {
                diff.push(k);
            }
            return diff;
        },
        async verifyPartsAndOperationsPrice(activeReceptionFlag) {
            let frontendPayload = {
                operations: this.operations,
                parts: this.parts
            }
            this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
            await this.$nextTick();
            this.fixShoppingCartByActiveReception(frontendPayload);
        },
        onChangeOperationRow() {
            this.firstRenderOperations++;
            if (this.operations.length < this.firstRenderOperations) {
                let frontendPayload = {
                    operations: this.computedBudgetSummary.operations.values,
                    parts: this.parts
                }
                this.$store.commit('budget/setShoppingCartCopy', frontendPayload);
                this.operations = this.computedBudgetSummary.operations.values;
            }
            if (this.operations.length == this.firstRenderOperations) {
                this.firstRenderOperations++;
            }

            if (this.$route.name === 'budget-summary' && this.firstRenderOfSummary <= 2) {
                //
            } else {
                this.netDataOperations = 0;
            }
        },
        searchForInactiveLaborValue() {
            let filterOperationsByHour = this.operations.map(el => el.hourValue.quotationLaborId);

            let findDifferenceLaborInactive = [];
            for (let i in this.computedLaborValues) {
                for (let key in filterOperationsByHour) {
                    if (this.computedLaborValues[i].quotationLaborId == +filterOperationsByHour[key] && this.computedLaborValues[i].isActive == false) {
                        findDifferenceLaborInactive.push(this.computedLaborValues[i]);
                    }
                }
            }

            if (findDifferenceLaborInactive.length > 0) {
                this.modalLaborValues.show = true;
                this.modalLaborValues.findDifferenceLaborInactive = findDifferenceLaborInactive;
            }

            // this.$store.commit('loadings/setStateLoadingTemplate', false);
        },
        onAcceptInactiveLabor() {
            let findOperationWithInactiveLabor = this.operations.filter(el => el.hourValue.quotationLaborId == this.modalLaborValues.findDifferenceLaborInactive[0].quotationLaborId)
            findOperationWithInactiveLabor.forEach(element => {
                Object.assign(element, {hasInactiveLabor: true})
            })

            for (let key in this.operations) {
                for (let i in findOperationWithInactiveLabor) {
                    if (this.operations[key].reference == findOperationWithInactiveLabor[i].reference) {
                        this.operations[key] = findOperationWithInactiveLabor[i];
                    }
                }
            }

            this.modalLaborValues.show = false;
            this.verifyPartsAndOperationsPrice();
        },
        async onDoesNotAcceptInactiveLabor() {
            this.operationsRowReady = false;
            let findFavouriteLaborValue = this.computedLaborValueActive.filter(el => el.isFavourite === true);

            let findOperationWithInactiveLabor = this.operations.filter(el => el.hourValue.quotationLaborId == this.modalLaborValues.findDifferenceLaborInactive[0].quotationLaborId)

            for (let key in this.operations) {
                for (let i in findOperationWithInactiveLabor) {
                    if (this.operations[key].reference == findOperationWithInactiveLabor[i].reference) {
                        this.operations[key].hourValue = findFavouriteLaborValue[0];
                    }
                }
            }

            await this.$nextTick();
            this.verifyPartsAndOperationsPrice();
            this.operationsRowReady = true;
            this.modalLaborValues.show = false;
        },
        noSaveOrder() {
            this.clearShoppingCart(true);
            //this.plateSearch(null, this.newPlate, null);
            localStorage.removeItem('@datadrive:planning-event');
        },
        yesSaveOrder() {
            this.modalAlertAlterPlate.show = false
            this.showModal(this.modal.types.SAVE);
            localStorage.removeItem('@datadrive:planning-event');
        },
        cancelModal() {
            this.modal.show = false

            // if(this.newPlate){
            //     this.noSaveOrder()
            // }
        },
        checkIfFluid(item) {
            if (Number.isInteger(item.quantity)) {
                return item?.isFluid && item.isFluid == true;
            } else {
                return true;
            }
        },
        checkClickedMenu() {
            this.modalAlertToLeave.show = true;
        },
        onSaveBudget() {
            this.modalAlertToLeave.show = false;
            this.modalAlertToLeave.needToRedirect = true;
            this.showModal(this.modal.types.SAVE);
        },
        async onDontSaveBudget() {
            const checkClickedRoute = this.$store.getters['sidebarActiveMenu/getStateSidebarActiveMenu'].routeSidebar;
            this.modalAlertToLeave.show = false;
            await this.clearShoppingCart(true);
            if (checkClickedRoute === '/') {
                this.modalAlertToLeave.needToRedirect = true;
                localStorage.clear();
                this.$cookies.remove('token', {secure: true, expires: 1});
                this.$store.commit('auth/setState', {});
                this.$store.commit('vehicleIdentification/setVehicleIdentificationClear');
                this.$router.push('/');
                location.reload();
            } else {
                document.location = checkClickedRoute;
            }
        },
        refFreePartRules(value) {

            let findEqualReference = _.some(this.computedBudgetSummary.parts.values, ['reference', value])

            if (findEqualReference) {
                return this.$t('module-budget.main-budget.reference-rule')
            }
            if (!findEqualReference) {
                return !!value || this.$t('module-budget.main-budget.mandatory-field')
            }
        },
        refFreeOperationRules(value) {

            let findSomeEqualRef = _.some(this.computedBudgetSummary.operations.values, ['reference', value])

            if (findSomeEqualRef) {
                return this.$t('module-budget.main-budget.reference-rule')
            }
            if (!findSomeEqualRef) {
                return !!value || this.$t('module-budget.main-budget.mandatory-field')
            }
        },
        onRejectGoToPlanning() {
            this.modalAskForPlanning.show = false;

            if (this.modalAskForPlanning.id === 5) {
                localStorage.removeItem('@datadrive:planning-event');
                let payload = {
                    quotationId: null,
                    cameFromBudget: false,
                    cameFromHistory: false,
                    plate: null,
                    internalId: null,
                    dataSourceId: null
                }
                this.$store.commit('planning/setPlanningBudgetState', payload);
                this.$store.commit('planning/setPlanningEvent', {})
                this.$router.push({name: 'dashboard'});
            } else {
                this.modalAskForStayOnThePage.show = true;
            }
        },
        onGoToPlanning() {
            this.modalAskForPlanning.show = false;
            let payload = {
                quotationId: this.newQuotationId,
                cameFromBudget: true,
                cameFromHistory: false,
                plate: null,
                internalId: null,
                dataSourceId: null
            }
            this.$store.commit('planning/setPlanningBudgetState', payload);

            const hasAnyPlanningEventOnVueStorage = this.$store.getters['planning/getPlanningEvent'];
            let hasAnyPlanningLocalStorage;
            if (hasAnyPlanningEventOnVueStorage && hasAnyPlanningEventOnVueStorage != undefined) {
                hasAnyPlanningLocalStorage = hasAnyPlanningEventOnVueStorage;
            } else {
                hasAnyPlanningLocalStorage = JSON.parse(localStorage.getItem('@datadrive:planning-event'))
            }

            if (hasAnyPlanningLocalStorage && hasAnyPlanningLocalStorage.eventRecord) {
                if (hasAnyPlanningLocalStorage.isCreate == true) {
                    let planObj = hasAnyPlanningLocalStorage.planningObject;
                    planObj.eventRecord.quotationId = this.newQuotationId;
                    this.$store.commit("planning/setNewPlanningEvent", {planningObject: hasAnyPlanningLocalStorage.planningObject});
                    this.$router.push({name: 'create-planning'});
                    this.clearShoppingCart(true);
                } else {
                    this.$store.commit("planning/setNewPlanningEvent", {planningId: hasAnyPlanningLocalStorage.eventRecord.planningId});
                    this.$router.push({
                        name: 'edit-planning',
                        params: {planningId: hasAnyPlanningLocalStorage.eventRecord.planningId}
                    });
                    this.clearShoppingCart(true);
                }
            } else {
                if (this.hasPlanningId !== null && this.hasPlanningId !== undefined) {
                    this.clearShoppingCart(true);
                    this.$store.commit("planning/setNewPlanningEvent", {planningId: this.hasPlanningId});
                    this.$router.push({name: 'edit-planning', params: {planningId: this.hasPlanningId}});
                } else {
                    this.clearShoppingCart(true);
                    this.$router.push({name: 'planning', params: {quotationId: this.newQuotationId}});
                }
            }
        },
        async onRejectToStay() {
            let processNummber = this.$store.getters['vehicleIdentification/getState'].processNumber;
            this.$store.commit('budget/setCurrentProcessNumberByCar', processNummber);
            this.$store.commit('budget/setB2bClearShoppingCart');
            this.$store.commit('budget/setB2bCurrentStep', 1);
            this.$store.commit('budget/setClearBudgetSummary', {});
            localStorage.removeItem('@datadrive:planning-event');
            let payload = {
                quotationId: null,
                cameFromBudget: false,
                cameFromHistory: false,
                plate: null,
                internalId: null,
                dataSourceId: null
            }
            this.$store.commit('planning/setPlanningBudgetState', payload);
            this.$store.commit('planning/setPlanningEvent', {});

            await this.$helpers.handleRenewProcessNumber(this.forceResolveVehicle);

            this.$router.push({name: 'dashboard'});
        },
        clickOutsideFunc(value) {
            this.modalAlertToLeave.show = value;
        },
        clickOutsideModalRemove(value) {
            this.modalAlertRemove.show = value;
        },
        clickOutsideAskForPlanning(value) {
            this.modalAskForPlanning.show = value;
        },
        clickOutsideModalAskForStay(value) {
            this.modalAskForStayOnThePage.show = value;
        },
        clickOutsideModalGoToPlanning(value) {
            this.modalGoToPlanning.show = value;
        },
        clickOutsideModalCheckEmptyPart(value) {
            this.modalCheckEmptyPart.show = value;
        },
        clickOutsideModalFreePart(value) {
            if (!value) {
                this.onCloseAddModal();
            }
        },
        clickOutsideModalAddOperationOrPart(value) {
            if (!value) {
                this.modalAddOperationOrPart.show = value;
            }
        },
        clickOutsideModalFreeOperation(value) {
            if (!value) {
                this.onCloseAddModal();
            }
        },
        onChangeAmount(event) {
            let newEventValue = _.cloneDeep(event);
            if (newEventValue.includes('.') || newEventValue.includes(',')) {
                return this.modalFreePart.newPart[0].amounts[0].amount = Number(event).toFixed(2);
            } else {
                return this.modalFreePart.newPart[0].amounts[0].amount = event
            }
        },
        onChangeAmountCost(value, id) {
            let newValue = _.cloneDeep(value);
            if (newValue.includes('.') || newValue.includes(',')) {
                const splitValue = newValue.split('.');
                if (splitValue[1].length <= 3) {
                    newValue = Number(newValue).toFixed(2);
                } else {
                    newValue = Number(newValue).toFixed(4);
                }
            } else {
                newValue = Number(newValue).toFixed(2);
            }

            if (id == 'costPrice') {
                return this.modalFreePart.newPart[0].costPrice = newValue;
            } else {
                return this.modalFreePart.newPart[0].partPrice = newValue;
            }
        },
        onAddServicePackage() {
            this.showPacksList = true;
            this.showPacksListFlag = true;
        },
        showPacksListMethod(value, close) {
            this.showPacksList = value;
            if (close && close == 'close') {
                this.showPacksListFlag = false;
            }
        },
        async handleGetPackageServicesTransformed(services) {
            if (services.operations && services.operations.length > 0) {
                services.operations.forEach(e => {
                    const findEquals = this.operations.some(o => o.itemMpId == e.itemMpId && o.workId == e.workId && o.names[0] == e.names[0])
                    if (!findEquals) {
                        this.operations.push(e);
                    }
                })
            }
            this.operations.forEach((e, index) => {
                const stringItemMpId = String(e.itemMpId);
                if (stringItemMpId.includes('-998')) {
                    const findEquals = services.operations.find(o => String(o.itemMpId) == String(e.itemMpId) && String(o.workId) == String(e.workId) && o.names[0] == e.names[0])
                    if (!findEquals) {
                        this.operations = this.operations.filter(op => String(op.itemMpId) != String(e.itemMpId))
                    }
                }
            })

            if (services.parts && services.parts.length > 0) {
                services.parts.forEach(e => {
                    let newEl = [e]
                    let part = {};
                    part[e.itemMpId] = newEl
                    this.parts = {
                        ...this.parts,
                        ...part
                    }
                })
            }

            let keysToRemove = [];
            for (var [key, value] of Object.entries(this.parts)) {
                const stringItemMpId = String(value[0].itemMpId);
                if (stringItemMpId.includes('-998')) {
                    const findEqual = services.parts.find(el => String(el.itemMpId) == String(value[0].itemMpId) && el.name == value[0].name);
                    if (!findEqual) {
                        keysToRemove.push(stringItemMpId)
                        delete this.parts[key];
                    }
                }
            }

            this.showPacksListFlag = false;

            let frontendPayload = {
                operations: this.operations,
                parts: this.parts
            }
            this.$store.commit('budget/setShoppingCartCopy', frontendPayload);

            this.$store.commit('budget/setMaintenanceShoppingCartOperations', frontendPayload.operations);

            this.$store.commit('budget/setMaintenanceShoppingCartParts', frontendPayload.parts);

            await this.$nextTick();

            let newArrOpFilter = [];
            this.computedBudgetSummary.operations.values.forEach(operat => {
                this.operations.forEach(op => {
                    if (String(op.itemMpId) == String(operat.itemMpId) && String(op.workId) == String(operat.workId) && operat.names[0] == op.names[0]) {
                        newArrOpFilter.push(operat);
                    }
                })
            })
            this.$store.commit('budget/setBudgetSummaryOperationsValues', newArrOpFilter);

            let newArrPtFilter = [];
            this.computedBudgetSummary.parts.values.forEach(part => {
                for (var [key, value] of Object.entries(this.parts)) {
                    const stringItemMpId = String(value[0].itemMpId);
                    const name = value[0].name;
                    if (stringItemMpId == String(part.itemMpId) && name == part.name) {
                        newArrPtFilter.push(part);
                    }
                }
            })

            if (keysToRemove && keysToRemove.length > 0) {
                const filterParts = newArrPtFilter.filter(obj => !keysToRemove.includes(String(obj.itemMpId)));
                const clonedFiler = _.cloneDeep(filterParts);
                this.sortedParts = this.sortedPartsFn(this.parts);
                this.$store.commit('budget/setBudgetSummaryPartsValues', clonedFiler)
            } else {
                this.$store.commit('budget/setBudgetSummaryPartsValues', newArrPtFilter);
            }

            await this.$nextTick();

            this.isReady = false;
            setTimeout(() => {
                this.isReady = true;
            }, 500);
        },
        getTotalizerTitle(title) {
            if (this.isCheckedIAM) {
                if (title == 1) return this.$t('module-budget.main-budget.totalizer-oe.title');
                if (title == 2) return this.$t('module-budget.main-budget.totalizer-oe.total-title');
            } else {
                return this.$t('module-budget.main-budget.totalizer-oe.total-value');
            }
        },
        async getEstimateWithInternalApiCalls(operationsBody, partsBody, isOnDelete, quotationId) {
            this.startProgressBar()

            if (this.$route.params.kms) {
                this.$store.commit('budget/setB2bKM', {
                    fields: {
                        Kilometers: this.$route.params.kms
                    }
                });
            }

            let responseGetQuotation = null;
            if (quotationId) {
                responseGetQuotation = await QuotationServicesGetQuotation(quotationId)
                if (responseGetQuotation) {
                    if (responseGetQuotation.result.observations) {
                        this.observationsQuotation = responseGetQuotation.result.observations;
                    }
                    this.hasPlanningId = responseGetQuotation.result?.planningId;
                    if (responseGetQuotation.result.hasInvoice) {
                        this.hasInvoice = true;
                        if (['budget-summary-edit'].indexOf(this.$route.name) >= 0) {
                            this.clearShoppingCart()
                        }
                    }

                    var filterOutServicePackages = responseGetQuotation.operations.filter(o => !o.entityPackageServiceId);
                    // if there's only one operation and it's called 'diagnóstico' duplicate the hourValue to all servicePackages
                    if (filterOutServicePackages.length == 1 && filterOutServicePackages[0].names.filter(name => name.toLowerCase().includes('diagnóstico')).length > 0) {
                        responseGetQuotation.operations.forEach(o => o.hourValue = filterOutServicePackages[0].hourValue);
                    }
                    if (responseGetQuotation.result.km || this.$route.params.kms) {
                        this.$store.commit('budget/setB2bKM', {
                            fields: {
                                Kilometers: responseGetQuotation.result.km ? responseGetQuotation.result.km : this.$route.params.kms
                            }
                        });
                    }

                    this.isPreviewOrEdit = true;
                    // this.vehicle = {
                    //     Make: responseGetQuotation.result.make,
                    //     Model: responseGetQuotation.result.model,
                    //     BodyGroup: responseGetQuotation.result.bodyGroup,
                    //     FuelType: responseGetQuotation.result.fuelType,
                    //     Version: responseGetQuotation.result.version,
                    //     KType: responseGetQuotation.result.kType,
                    //     ManualPlate: responseGetQuotation.result.manualPlate,
                    //     plateNumber: ''
                    // }

                    this.vehicleInfo = `${responseGetQuotation.result.make} ${responseGetQuotation.result.model}`
                    if (responseGetQuotation.result?.version) {
                        this.vehicleInfo = `${this.vehicleInfo} ${responseGetQuotation.result.version}`
                    }

                    const opDisc = responseGetQuotation.operationsGlobalDiscount;
                    const ptDisc = responseGetQuotation.partsGlobalDiscount;

                    await this.handleWithActiveReceptionAndGetQuotationResponses(responseGetQuotation.operations, responseGetQuotation.parts, operationsBody, partsBody, isOnDelete, quotationId, opDisc, ptDisc);
                }
            } else {
                await QuotationServicesGetEstimateInternalData(operationsBody, partsBody)
                    .then(response => {
                        this.operations = response.operations;
                        this.parts = response.parts;

                        for (let key in this.parts) {
                            this.parts[key].map(el => {
                                if (!el.reference) {
                                    el.reference = ''
                                }
                            })
                        }

                        if (response) {
                            const activeReceptionFlag = true;
                            this.resolveFreeOperationsAndParts(activeReceptionFlag);
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        this.modalRequest.show = true;
                        console.error('Error in getEstimateWithInternalApiCalls', error);
                    })
                    .finally(() => {
                        if (isOnDelete) {
                            this.isReady = false;
                            setTimeout(() => {
                                this.isReady = true;
                            }, 5);
                        }

                        this.stopProgressBar();

                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                        //this.$router.replace({name: 'budget-summary-edit', params: {id: quotationId}});
                        this.showDiagnosticTotalizer = true;
                    });
            }

        },
        async fixShoppingCartByActiveReception(frontendPayload) {
            // TODO pegar o copyCart e transformar no shoppingCart normal
            const newShoppingCart = {
                operations: {
                    maintenance: frontendPayload.operations,
                    repair: []
                },
                parts: [],
                numberOfChanges: frontendPayload.operations.length,
                needToCheckItemMpId: null,
                lastDeletedItem: '',
            }
            this.$store.commit('budget/setForceShoppingCart', newShoppingCart);
            await this.$nextTick();
        },
        handleChangeTheObservations(value) {
            this.observationsQuotation = value;
        },
        async getBusinessConditions() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);
            const userId = this.$store.getters['auth/getState'].userId;
            const moduleId = 2;
            return UserServicesGetBusinessConditions(userId, moduleId)
                .then(async response => {
                    if (response.data && response.data.result.length > 0) {
                        this.businessConditionData = response.data.result;
                        let hasIamQuotationActive = false;
                        await response.data.result.forEach(bc => {
                            if (bc.businessConditionID == 14) {
                                hasIamQuotationActive = bc.isSelected;
                                this.hasIamQuotationBusinessConditionActive = bc.isSelected;
                            }
                            if (bc.businessConditionID == 6) {
                                this.isPartsTruncate = bc.isSelected;
                            }
                        })
                        if (this.computedCheckWebshop) {
                            this.actionButtons.push(
                                {
                                    text: this.$t('module-budget.main-budget.action-buttons.send-webshop'),
                                    icon: 'mdi-cart-outline',
                                    clickEvent: this.sendWebShopClicked
                                }
                            )
                        } else if (hasIamQuotationActive) {
                            this.actionButtons.push(
                                {
                                    text: this.$t('call-iam-quotation'),
                                    icon: 'mdi-cart-outline',
                                    clickEvent: this.askIamQuotation
                                }
                            )
                        }
                    }
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
        },
        async handleGetClientInformation() {
            if (this.$route.name == 'budget-summary' && this.$route.params.quotationId) {
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const quotationId = this.$route.params.quotationId;
                return QuotationServicesGetClientInformation(quotationId)
                    .then((response) => {
                        if (response.data && response.data.result) {
                            this.observationsQuotation = response.data.result?.observations ? response.data.result.observations : '';
                        }
                    })
                    .catch((error) => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            }
        },
        async askIamQuotation() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);
            let body = {
                iamParts: this.computedBudgetSummary.parts.values
                    .filter(part => !String(part.itemMpId).includes('-999'))
                    .map(part => {
                        // Se tiver toggle iam ativo, procurar pela referência OE
                        let refOE = part.reference;
                        let refIAM = part.reference;

                        if (!part.isIam) {
                            refIAM = '';
                        } else {
                            for (const value of Object.values(this.parts)) {
                                for (const element of value) {
                                    if (String(element.itemMpId) == String(part.itemMpId) && element.isIam) {
                                        refOE = element.reference;
                                    }
                                }
                            }
                        }
                        return {
                            isFluid: part.isFluid,
                            itemMpId: part.itemMpId,
                            referenceOE: refOE,
                            referenceIAM: refIAM,
                            quantity: part.quantity,
                            description: part.name ? part.name : '',
                            brandDescription: part.brand ? part.brand : this.computedBrandOfVehicle,
                            isIam: part.isIam ? part.isIam : false,
                            additionalDescription: this.checkIfFluid(part) && !this.checkIfIsEcolub(part) && part.aditionalDescription ? part.aditionalDescription : '',
                        };
                    }),
            }
            if (this.$route.params.id) {
                body['quotationId'] = this.$route.params.id
            }
            await QuotationServicesDownloadIamRequest(body)
                .then(response => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                    const file = new Blob([response.data], {type: 'application/pdf'});
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
        },
        async callContactoOrderPartAbove() {
            this.$store.commit('loadings/setStateLoadingTemplate', true);
            await EntityServicesGetEntityContactPart()
                .then(response => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                    if (response.data && response.data.result && response.data.result.contacts && response.data.result.contacts.length > 0) {
                        for (let i = 0; i < response.data.result.contacts.length; i++) {
                            this.orderIamEmail += response.data.result.contacts[i].email;
                            if (i != response.data.result.contacts.length - 1) {
                                this.orderIamEmail += '; ';
                            }
                        }
                        this.emailExists = true;
                    } else {
                        this.emailExists = false;
                    }
                    if (response.data && response.data.result) {
                        this.isEmailDisabled = response.data.result.isInputReadOnly;
                    }

                })
                .catch(error => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                })
        },
        sortedPartsFn(partsSorted) {
            const sortedData = [];
            let apiPartOrder = 0;

            Object.values(partsSorted).forEach((partArray) => {
                partArray[0]['apiPartOrder'] = apiPartOrder++;
                sortedData.push(partArray);
            });

            return sortedData;
        },
        async handleWithActiveReceptionAndGetQuotationResponses(resOperationsGet, resPartsGet, operationsBody, partsBody, isOnDelete, quotationId, opDisc, ptDisc) {
            let responsePartsInternals = null;
            let responseOperationsInternals = null;
            let responseOperationsGet = resOperationsGet;
            let responsePartsGet = resPartsGet;

            await QuotationServicesGetEstimateInternalData(operationsBody, partsBody)
                .then(response => {
                    let newParts = {}
                    for (let key in responsePartsGet) {
                        if (response.parts.hasOwnProperty(key)) {
                            newParts[key] = responsePartsGet[key];
                        } else {
                            newParts[key] = responsePartsGet[key];
                        }
                    }
                    for (let key in response.parts) {
                        if (!responsePartsGet.hasOwnProperty(key)) {
                            newParts[key] = response.parts[key];
                        }
                    }
                    this.parts = newParts;

                    let newOperationsArr = []

                    function existsInArray(element, arr) {
                        for (let i = 0; i < arr.length; i++) {
                            if (String(arr[i].workId) === String(element.workId) && String(arr[i].itemMpId) === String(element.itemMpId)) {
                                return true;
                            }
                        }
                        return false;
                    }

                    responseOperationsGet.forEach(element => {
                        if (existsInArray(element, response.operations)) {
                            newOperationsArr.push(element);
                        } else {
                            newOperationsArr.push(element);
                        }
                    });
                    response.operations.forEach(element => {
                        if (!existsInArray(element, responseOperationsGet)) {
                            newOperationsArr.push(element);
                        }
                    });
                    this.operations = newOperationsArr;

                    for (let key in this.parts) {
                        this.parts[key].map(el => {
                            if (!el.reference) {
                                el.reference = ''
                            }
                        })
                    }

                    this.globalOperationsDiscount = opDisc;
                    this.globalPartsDiscount = ptDisc;

                    if (!this.isPreview) {
                        let maintenance = this.operations;
                        maintenance = maintenance.map(item =>
                            Object.assign(item, {
                                workPosDescription: item.names[0],
                                singleWorkTime: +item.duration.hours,
                                totalWorkTime: +item.duration.minutes
                            })
                        );

                        /**
                         * START
                         * Way to solve a problem in the short term.
                         * The BudgetSummary computed was looping from too many calls.
                         * That was the way to fix it quickly. We should refactor this code obviously
                         */
                        new Promise((resolve, reject) => {
                            try {
                                resolve(this.$store.commit('budget/setMaintenanceShoppingCartOperations', maintenance));
                            } catch (e) {
                                reject("error on primise get budget promisse", e);
                            }
                        }).then(() => {
                            setTimeout(() => {
                                this.$store.commit('budget/setMaintenanceShoppingCartParts', this.parts);
                            }, 500);
                        }).then(() => {
                            setTimeout(() => {
                                this.$store.commit('budget/setB2bShoppingCartNumberOfParts');
                            }, 500);
                        })
                        // END

                        let payload = {
                            maintenance: maintenance,
                            parts: this.parts,
                            quotationId: this.$route.params.id,
                            internalId: this.$route.params.token
                        };
                        this.$store.commit('budget/setLastBudgetSelectedToCompare', payload);
                    }

                    if (this.operations) {
                        this.searchForInactiveLaborValue();
                    }

                    if (response) {
                        const activeReceptionFlag = true;
                        this.resolveFreeOperationsAndParts(activeReceptionFlag);
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    this.modalRequest.show = true;
                    console.error('Error in getEstimateWithInternalApiCalls', error);
                })
                .finally(() => {
                    if (isOnDelete) {
                        this.isReady = false;
                        setTimeout(() => {
                            this.isReady = true;
                        }, 5);
                    }

                    this.stopProgressBar();

                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                    this.$router.replace({name: 'budget-summary-edit', params: {id: quotationId}});
                    this.showDiagnosticTotalizer = true;
                });
        },
        async handleChangeOePartDrop(receivedPart, oldPart) {
            for (let key in this.parts) {
                this.parts[key].map(el => {
                    if (String(el.partId) == String(oldPart.partId) && String(el.itemMpId) == String(oldPart.itemMpId) && String(el.workId) == String(oldPart.workId)) {
                        el.isSelected = false;
                    }
                })
            }
        },
        async handleWithOperationTotalsForTotalizerOE(value) {
            this.dataOperationTotalsForTotalizerOE = value.totalWithDiscount;
        },
        enableSwitch(part) {
            return (
                !this.isIam &&
                !this.isIamWithoutSM &&
                this.checkIfFluid(part) &&
                !this.checkIfIsEcolub(part) &&
                part.iamParts &&
                part.iamParts.length > 0
            );
        },
        disablePartSwitch(part) {
            return (
                this.isPreview ||
                (this.isIamWithoutSM &&
                    (this.checkIfIsFreePart(part) ||
                        this.checkIfIsPackageService(part) ||
                        this.checkIfIsEcolub(part)))
                || (part.iamParts.length == 0 && !this.isIamWithoutSM)
            );
        },
        async onClickContactSupplier() {
            const partsClone = this.parts;
            let newArrayOfParts = [];

            for (let key in partsClone) {
                let internArray = partsClone[key];
                let element = internArray.find(o => o.isSelected);
                let refOE = element.reference;
                let refIAM = element.reference;
                let quantity = element.quantities.find(e => e.isSelected).quantity
                let brand = '';
                let brandId = '';
                let theName = element.name;

                if (element.isIam) {
                    if (element.iamParts && element.iamParts.length > 0) {
                        const findSelected = element.iamParts.find(p => p.isSelected == true);
                        if (findSelected) {
                            refIAM = findSelected.reference ? findSelected.reference : '';
                            quantity = findSelected.quantity ? findSelected.quantity : 1;
                            brand = findSelected.brand ? findSelected.brand : '';
                            brandId = findSelected.brandId ? findSelected.brandId : '';
                            theName = findSelected.name ? findSelected.name : element.name
                        }
                    }
                } else {
                    this.computedBudgetSummary.parts.values.forEach(part => {
                        if (element.itemMpId == part.itemMpId) {
                            theName = part.name ? part.name : element.name;
                            refOE = part.reference ? part.reference : element.reference;
                        }
                    })
                }

                let newObj = {
                    ...element,
                    name: theName,
                    referenceOE: refOE,
                    referenceIAM: element.isIam && element.isIam !== '' ? refIAM : '',
                    brand: brand,
                    quantity: quantity,
                    qtd: String(quantity),
                    brandId: brandId,
                    isIam: !!(element.isIam && element.isIam !== ''),
                    highlight: (!element.isIam && !refOE) || (element.isIam && element.isIam !== '' && !refIAM) || (this.disablePartSwitch(element) && !this.enableSwitch(element)),
                }
                newObj.requiresHighlight = newObj.highlight;

                if (this.checkIfIsEcolub(newObj) == false) {
                    newArrayOfParts.push(newObj);
                }
            }
            await this.$nextTick();
            this.modalContactSupplier.parts = newArrayOfParts;
            this.modalContactSupplier.show = true;
        },
        loadBudgetData(id) {
            this.getBudgetData(null, this.loadVehicle, this.$route.params.carInfo);
        },
    },
    created() {
        const findTotalsOnLocalStorage = JSON.parse(localStorage.getItem('@shoppingCartTotals'));
        if (findTotalsOnLocalStorage) {
            this.globalOperationsDiscount = findTotalsOnLocalStorage.operations.totals.globalDiscount;
            this.globalPartsDiscount = findTotalsOnLocalStorage.parts.totals.globalDiscount;
        }
    },
    mounted() {
        this.amISupplier();
        this.routeName = this.$route.name;
        this.edit = this.$route.params.edit;

        if (this.$route.params.activeReception) {
            this.getEstimateWithInternalApiCalls(
                this.$route.params.operationsBody,
                this.$route.params.partsBody,
                null,
                this.$route.params.quotationId
            );
        } else if(this.edit || this.$route.name == "budget-summary-edit") {
          this.getBudgetData(null, this.loadVehicle, this.$route.params.carInfo);
        }
        this.allLaborValues = this.$store.getters['budget/getB2bLaborValues'];
        this.checkBudgetStartedBy;

        this.getBusinessConditions();
        this.handleGetClientInformation();

        this.$store.commit('budget/setB2b', {maintenancePlanHtml: {show: false, id: 0}});
        this.$store.commit('techInfo/setTechInfo', {maintenancePlanHtml: {show: false, id: 0}});
    },

    beforeDestroy() {
        if (this.routeName == 'budget-summary-preview') {
            this.clearShoppingCart(true);
        }
        this.$store.commit('budget/setQuotationType', {});
    },

    beforeRouteUpdate(to, from, next) {
        if (to.params.id !== this.$route.params.id) {
            this.loadBudgetData(to.params.id);
        }
        next();
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
          if(!to.params.activeReception) {
            vm.loadBudgetData(to.params.id);
          }
        });
    },
};
</script>

<style lang="scss" scoped>
@import '@components/b2b/budget/operations/table-style.scss';

.fade-enter-active {
    transition: opacity 2s !important;
}

.container--obs {
    margin: 0px;
    padding: 10px 25px !important;
    background-color: white !important;
    margin-bottom: 20px;
}

.fade-enter,
.fade-leave-to {
    opacity: 0 !important;
}

.spans-loading {

    margin-top: 25px;
    font-size: 16px;
    text-align: center;
    animation: fadein 2s;
    -moz-animation: fadein 2s; /* Firefox */
    -webkit-animation: fadein 2s; /* Safari and Chrome */
    -o-animation: fadein 2s; /* Opera */

    @keyframes fadein {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    @-moz-keyframes fadein { /* Firefox */
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    @-webkit-keyframes fadein { /* Safari and Chrome */
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    @-o-keyframes fadein { /* Opera */
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
}

.tables-container {
    max-width: 1520px;
    margin: 0 auto;
}

.btn-action {
    background-color: white !important;
    border: 1px solid var(--v-primary-base);
    border-radius: 43px !important;
    transition: all .5s;

    &:hover {
        transition: all 1s;
        background-color: var(--v-primary-base) !important;

        .primary--text {
            color: #fff !important;
        }
    }
}


.input-number {
    ::v-deep input {
        text-align: right;
        min-width: 65px !important;
    }
}


.stepper {
    width: 100%;
    margin-top: -30px;
    display: flex;
    @media(max-width: 959px) {
        margin-top: 20px;
    }

    ul {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        list-style: none;
        width: 100%;
        margin: 0;
        padding: 0;

        li {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 33.33%;
            cursor: pointer;

            &.active {
                &:last-child {
                    .text {
                        color: var(--v-primary-base);
                    }
                }

                .circle {
                    background-color: var(--v-primary-base);
                }
            }

            .circle {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                background-color: #9e9d9d;
                border-radius: 50px;
                z-index: 2;
            }

            .text {
                color: #969393;
                text-align: center;
                font-size: 14px;
            }

            .line__bottom--step {
                position: relative;
                border-bottom: 1px dashed var(--v-primary-base);
                top: 12px;

                &.w-50 {
                    width: 50%;
                }

                &.w-100 {
                    width: 100%;
                }

                &.l-50 {
                    margin-left: 50%;
                }

                &.r-50 {
                    margin-right: 50%;
                }
            }
        }
    }
}

.btn-custom-budget {
    ::v-deep .v-btn__content {
        font-size: 16px;

        .plus {
            padding-top: 3px;
        }
    }
}


.btn-color-blue {
    background-color: $btn-color-blue !important;
    translate: all .5s;

    &:hover {
        background-color: $btn-color-blue-hover !important;
        translate: all .5s;
    }

    span {
        font-weight: bold;
    }

    span, small {
        color: #fff;
    }
}

.btn-color-red {
    background-color: $btn-color-red !important;
    translate: all .5s;

    ::v-deep .v-btn__content {
        color: #fff !important;
        font-weight: bold !important;
    }

    &:hover {
        background-color: $btn-color-red-hover !important;
        translate: all .5s;
    }
}

.btn-color-green {
    background-color: $btn-color-green !important;

    translate: all .5s;

    ::v-deep .v-btn__content {
        color: #fff !important;
        font-weight: bold !important;
    }

    &:hover {
        background-color: $btn-color-green-hover !important;
        translate: all .5s;
    }
}

.base-page-header-container {
    margin-bottom: 0;
}


.stepers-row {
    margin-top: -20px;

    .text-vehicle {
        font-size: 14px;
        color: #9E9D9D;
    }

    @media (max-width: 959px) {
        margin-top: 0;

        .text-vehicle {
            text-align: center;
        }
    }
}

.container__row--title {
    background: var(--v-primary-base) !important;

    h3, span {
        color: $white !important;
    }

    .container__col--title {
        justify-content: flex-start !important;
    }
}

table {
    tr {
        border-bottom: 1px solid #E7E7E7;

        th {
            padding-bottom: 4px !important;
        }

        /*
        td {
            padding-top: 15px !important;
        } */
    }
}

.btn-span {
    cursor: pointer;

    &:hover {
        color: var(--v-primary-base);
    }
}

.div-white-buttons {

    @media(min-width: 1441px) {
        display: flex;
        flex-direction: row;
        max-width: 35%;
    }

    @media(max-width: 426px) {
        align-items: center;
    }

    @media(max-width: 1025px) {
        display: flex;
        flex-direction: column;
        max-width: 100%;
    }
}

.row-actions-final {
    @media(min-width: 1441px) {
        display: flex;
    }
}

.icons-title {
    ::v-deep svg {
        path {
            fill: #fff !important;
        }
    }
}

.v-progress-linear--rounded {
    border-radius: 10px;
}

</style>
